import { jsx as e, jsxs as d, Fragment as ye } from "react/jsx-runtime";
import * as z from "react";
import { useMemo as X, Suspense as ir, useState as I, useRef as $e, useEffect as ie, useCallback as we, useId as ar, createContext as sr, useContext as lr } from "react";
import { Breadcrumb as cr, Card as ze, Layout as le, theme as Z, Grid as xt, Spin as vn, ConfigProvider as kn, Tooltip as Cn, Typography as $, Space as G, Tag as be, Button as M, Menu as xn, Avatar as _n, Badge as dr, DatePicker as Tn, Empty as ur, Drawer as mr, App as xe, Steps as _t, Form as _, Select as Xe, InputNumber as Tt, Modal as Ze, Input as W, Popconfirm as hr, Alert as Ye, Tree as gr, Table as ee, Descriptions as de, Divider as pr, Row as gt, Col as it, Progress as fr, Radio as Ke, Checkbox as Oe, Upload as yr, Collapse as br } from "antd";
import { Link as at, Outlet as Sr, useNavigate as ct, useLocation as wr } from "react-router-dom";
import { ChevronDownIcon as vr, BellIcon as kr } from "@heroicons/react/24/outline";
import { MenuUnfoldOutlined as Cr, MenuFoldOutlined as xr, DeleteOutlined as An, SearchOutlined as _r, DownloadOutlined as Tr, PrinterOutlined as Ar, InboxOutlined as Nr, SunOutlined as Lr, MoonOutlined as Ir, CheckCircleFilled as Dr, FacebookFilled as Pr } from "@ant-design/icons";
import { createAdminSidebarMenuTokens as Ur, useTheme as At, useLocale as Er } from "@digiwedge/ui-theme";
import { AppThemeProvider as Ll, dark as Il, light as Dl, useTheme as Pl } from "@digiwedge/ui-theme";
import te from "dayjs";
import Mr from "dayjs/plugin/advancedFormat.js";
import Rr from "dayjs/plugin/customParseFormat.js";
import Br from "dayjs/plugin/isoWeek.js";
import Fr from "dayjs/plugin/localeData.js";
import $r from "dayjs/plugin/weekday.js";
import Or from "dayjs/plugin/weekOfYear.js";
import qr from "dayjs/plugin/weekYear.js";
import { ResponsiveContainer as zr, BarChart as Hr, XAxis as Wr, YAxis as Vr, Tooltip as jr, ReferenceLine as Zt, Bar as Gr } from "recharts";
import { getMessage as m } from "@digiwedge/i18n-messages";
import { z as Yr } from "zod";
import { useMutation as Kr, QueryClient as Qr, QueryClientProvider as Xr } from "@tanstack/react-query";
import { TenantsApi as Zr } from "@digiwedge/access-control-api-client";
import { decodeExp as Jr, resolveAudience as eo, useLogin as Nn, useVerifyLoginMfa as to, getAuthBroadcastSourceId as no, broadcastAuthEvent as ro, resetRefreshBlock as oo, classifyAxiosError as Jt, useRegister as Ln, useLogout as io, useRegisterSmsMfa as ao, useVerifySmsMfa as so } from "@digiwedge/hooks-auth-web";
import { getTokenDeliveryMode as en } from "@digiwedge/idp-client";
import { useGlobalStore as mt } from "@digiwedge/global-state";
import { isAxiosError as tn } from "axios";
import { parseLocationForOAuthError as lo } from "@digiwedge/oauth-redirect-utils";
const Bs = ({
  breadcrumbItems: t = [],
  separator: n = ">",
  style: r = { margin: "16px 0" },
  renderItem: o
}) => {
  const i = X(() => t.map((a, l) => {
    const s = l === t.length - 1;
    let c;
    return o ? c = o(a, s) : s ? c = /* @__PURE__ */ e("span", { style: { fontWeight: "bold" }, children: a.name }) : c = a.path ? /* @__PURE__ */ e(at, { to: a.path, children: a.name }) : a.name, { title: c };
  }), [t, o]);
  return /* @__PURE__ */ e(cr, { items: i, separator: n, style: r });
}, Fs = ({ img: t, icon: n, title: r }) => /* @__PURE__ */ d(
  ze,
  {
    hoverable: !0,
    style: { width: "100%", borderRadius: 12 },
    bodyStyle: {
      padding: 12,
      display: "flex",
      alignItems: "center",
      gap: 4,
      whiteSpace: "nowrap"
    },
    cover: /* @__PURE__ */ e(
      "div",
      {
        style: {
          height: 120,
          backgroundImage: `url(${t})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }
      }
    ),
    children: [
      n,
      /* @__PURE__ */ e(
        "div",
        {
          style: {
            fontWeight: 600,
            fontSize: 14,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          children: r
        }
      )
    ]
  }
), { Content: co } = le, $s = ({
  children: t,
  padding: n,
  responsivePadding: r
}) => {
  const {
    token: { colorBgContainer: o }
  } = Z.useToken(), i = xt.useBreakpoint(), a = z.useMemo(() => {
    if (r) {
      const l = ["xxl", "xl", "lg", "md", "sm", "xs"];
      for (const s of l)
        if (i[s] && typeof r[s] == "number")
          return r[s];
    }
    return typeof n == "number" ? n : 24;
  }, [i, n, r]);
  return /* @__PURE__ */ e(
    co,
    {
      style: {
        padding: a,
        minHeight: "calc(100vh - 64px - 70px)",
        // Adjust for header and footer
        background: o
        // Dynamic background color based on theme
      },
      children: /* @__PURE__ */ e(
        ir,
        {
          fallback: /* @__PURE__ */ e(
            vn,
            {
              size: "large",
              style: {
                display: "block",
                margin: "auto",
                marginTop: "20%"
                // Center the spinner vertically
              }
            }
          ),
          children: t || /* @__PURE__ */ e(Sr, {})
        }
      )
    }
  );
}, Ne = 48, In = "env(safe-area-inset-bottom)", Os = (t) => `calc(${t}px + ${In})`, { Footer: uo } = le, mo = {
  facebook: /* @__PURE__ */ e("i", { className: "fab fa-facebook" }),
  twitter: /* @__PURE__ */ e("i", { className: "fab fa-twitter" }),
  instagram: /* @__PURE__ */ e("i", { className: "fab fa-instagram" }),
  linkedin: /* @__PURE__ */ e("i", { className: "fab fa-linkedin" })
  // Add more icons as needed
}, ho = ({
  text: t = "© 2025 DigiWedge. All rights reserved.",
  style: n,
  socialMedia: r = [],
  bgColor: o,
  borderColor: i,
  highlightColor: a,
  themeMode: l,
  brandName: s = "Tee Time",
  brandDescription: c = "Book tee times, discover golf clubs, and enjoy exclusive deals. Your perfect round starts here.",
  quickLinks: u = [
    { label: "Find Clubs", href: "/clubs" },
    { label: "Featured Deals", href: "/specials" },
    { label: "About Us", href: "/about" },
    { label: "Contact", href: "/contact" },
    { label: "FAQ", href: "/faq" }
  ],
  contactEmail: h = "support@teetime.com",
  contactPhone: p = "+1 234 567 890",
  showNewsletter: A = !0,
  newsletterTitle: C = "Subscribe to our Newsletter",
  newsletterPlaceholder: y = "Your email",
  newsletterButtonLabel: v = "Subscribe"
}) => {
  const { token: w } = Z.useToken(), P = l ?? "light", b = l != null ? Z.getDesignToken({
    algorithm: P === "dark" ? Z.darkAlgorithm : Z.defaultAlgorithm
  }) : w, O = o ?? b.colorBgContainer, F = i ?? b.colorSplit ?? b.colorBorderSecondary, H = b.colorText, k = b.colorTextDescription ?? b.colorTextSecondary ?? H, S = a ?? b.colorPrimary, U = b.colorBgLayout, f = `clamp(${b.paddingSM}px, 6vw, ${b.paddingXL}px)`, E = u ?? [], L = E.length > 0, j = !!(h || p), B = {
    textAlign: "center",
    padding: 0,
    marginTop: b.marginXL,
    backgroundColor: O,
    color: H,
    borderTop: `1px solid ${F}`,
    ...n
  }, Q = /* @__PURE__ */ d(uo, { style: { ...B }, children: [
    /* @__PURE__ */ d(
      "div",
      {
        style: {
          width: "100%",
          padding: `24px ${f}`,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: b.marginLG,
          minHeight: Ne
        },
        children: [
          /* @__PURE__ */ d("div", { style: { marginBottom: b.marginMD, textAlign: "left", maxWidth: 320 }, children: [
            /* @__PURE__ */ e(
              "div",
              {
                style: {
                  fontWeight: 700,
                  fontSize: 22,
                  color: S,
                  marginBottom: b.marginSM
                },
                children: s
              }
            ),
            /* @__PURE__ */ e("div", { style: { color: k, fontSize: 14 }, children: c })
          ] }),
          L && /* @__PURE__ */ d("div", { style: { marginBottom: b.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: b.marginSM }, children: "Quick Links" }),
            /* @__PURE__ */ e("div", { style: { display: "flex", flexDirection: "column", gap: 4 }, children: E.map((Y) => /* @__PURE__ */ e("a", { href: Y.href, style: { color: H }, children: Y.label }, Y.href)) })
          ] }),
          j && /* @__PURE__ */ d("div", { style: { marginBottom: b.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: b.marginSM }, children: "Contact" }),
            /* @__PURE__ */ d("div", { style: { fontSize: 14 }, children: [
              h && /* @__PURE__ */ d(ye, { children: [
                "Email:",
                " ",
                /* @__PURE__ */ e("a", { href: `mailto:${h}`, style: { color: S }, children: h })
              ] }),
              h && p && /* @__PURE__ */ e("br", {}),
              p && /* @__PURE__ */ d(ye, { children: [
                "Phone:",
                " ",
                /* @__PURE__ */ e("a", { href: `tel:${p.replace(/\s/g, "")}`, style: { color: H }, children: p })
              ] })
            ] }),
            /* @__PURE__ */ e("div", { style: { marginTop: b.marginSM }, children: r.length > 0 ? r.map(
              (Y) => Y.href ? /* @__PURE__ */ e(
                "a",
                {
                  href: Y.href,
                  "aria-label": Y.platform,
                  style: { margin: "0 8px", color: S },
                  children: Y.icon || mo[Y.platform.toLowerCase()]
                },
                Y.href
              ) : null
            ) : /* @__PURE__ */ d(ye, { children: [
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://facebook.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Facebook",
                  style: { margin: "0 8px", color: S },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-facebook" })
                }
              ),
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://twitter.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Twitter",
                  style: { margin: "0 8px", color: S },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-twitter" })
                }
              ),
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://instagram.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Instagram",
                  style: { margin: "0 8px", color: S },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-instagram" })
                }
              )
            ] }) })
          ] }),
          A && /* @__PURE__ */ d("div", { style: { marginBottom: b.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: b.marginSM }, children: C }),
            /* @__PURE__ */ d(
              "form",
              {
                onSubmit: (Y) => Y.preventDefault(),
                style: { display: "flex", gap: b.marginSM, flexWrap: "wrap" },
                children: [
                  /* @__PURE__ */ e(
                    "input",
                    {
                      type: "email",
                      placeholder: y,
                      "aria-label": y,
                      style: {
                        flex: 1,
                        padding: 6,
                        borderRadius: b.borderRadius,
                        border: `1px solid ${b.colorBorder}`,
                        background: b.colorBgContainer,
                        color: H
                      }
                    }
                  ),
                  /* @__PURE__ */ e(
                    "button",
                    {
                      type: "submit",
                      style: {
                        background: S,
                        color: b.colorTextLightSolid,
                        border: "none",
                        borderRadius: b.borderRadius,
                        padding: "6px 14px",
                        fontWeight: 600,
                        cursor: "pointer"
                      },
                      children: v
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e(
      "div",
      {
        style: {
          color: k,
          fontSize: 13,
          padding: "16px 0",
          width: "100%",
          backgroundColor: U
        },
        children: /* @__PURE__ */ d(
          "div",
          {
            style: {
              width: "100%",
              padding: `0 ${f}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              rowGap: b.marginSM,
              whiteSpace: "nowrap"
            },
            children: [
              /* @__PURE__ */ e("p", { style: { margin: 0 }, children: t }),
              /* @__PURE__ */ e("div", { style: { width: "100%" } }),
              /* @__PURE__ */ d("div", { style: { display: "flex", gap: 16, whiteSpace: "nowrap" }, children: [
                /* @__PURE__ */ e("a", { href: "/terms", style: { color: k }, children: "Terms of Service" }),
                /* @__PURE__ */ e("a", { href: "/privacy", style: { color: k }, children: "Privacy Policy" })
              ] })
            ]
          }
        )
      }
    )
  ] });
  return l ? /* @__PURE__ */ e(
    kn,
    {
      theme: { algorithm: P === "dark" ? Z.darkAlgorithm : Z.defaultAlgorithm },
      children: Q
    }
  ) : Q;
}, qs = ho, { Footer: go } = le, nn = {
  dev: { color: "geekblue", label: "DEV" },
  uat: { color: "gold", label: "UAT" },
  prod: { color: "success", label: "PROD" }
}, po = 7, zs = ({
  orgName: t,
  env: n,
  version: r,
  commit: o,
  syncInfo: i,
  links: a,
  bordered: l = !0
}) => {
  const { token: s } = Z.useToken(), c = s.colorBgContainer, u = s.colorSplit ?? s.colorBorderSecondary, h = s.colorTextDescription ?? s.colorTextSecondary, p = `clamp(${s.paddingSM}px, 5vw, ${s.paddingLG}px)`, A = i ? i.tooltip ? /* @__PURE__ */ e(Cn, { title: i.tooltip, placement: "top", children: /* @__PURE__ */ e($.Text, { style: { color: h }, children: i.label }) }) : /* @__PURE__ */ e($.Text, { style: { color: h }, children: i.label }) : null, C = r ? /* @__PURE__ */ d($.Text, { style: { color: h }, children: [
    "v",
    r
  ] }) : null, y = o ? /* @__PURE__ */ e($.Text, { code: !0, style: { color: h }, children: o.slice(0, po) }) : null, v = a?.length ? /* @__PURE__ */ e(G, { size: s.marginSM, wrap: !0, children: a.map((w) => /* @__PURE__ */ e($.Link, { href: w.href, style: { color: s.colorPrimary }, children: w.label }, w.href)) }) : null;
  return /* @__PURE__ */ e(
    go,
    {
      style: {
        background: c,
        borderTop: l ? `1px solid ${u}` : void 0,
        padding: `${s.paddingSM}px ${p}`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: s.marginSM,
            minHeight: Ne
          },
          children: [
            /* @__PURE__ */ d(G, { size: s.marginSM, wrap: !0, children: [
              /* @__PURE__ */ e($.Text, { strong: !0, children: t ?? "DigiWedge Admin" }),
              A
            ] }),
            /* @__PURE__ */ d(G, { size: s.marginSM, wrap: !0, children: [
              n ? /* @__PURE__ */ e(be, { color: nn[n].color, children: nn[n].label }) : null,
              C,
              y,
              v
            ] })
          ]
        }
      )
    }
  );
}, { Footer: fo } = le, Hs = ({
  primary: t,
  secondary: n,
  status: r,
  sticky: o = !0,
  safeArea: i = !0
}) => {
  const { token: a } = Z.useToken(), l = a.colorBgContainer, s = a.colorSplit ?? a.colorBorderSecondary, c = i ? `calc(${a.paddingSM}px + ${In})` : `${a.paddingSM}px`;
  return /* @__PURE__ */ e(
    fo,
    {
      style: {
        background: l,
        borderTop: `1px solid ${s}`,
        padding: `${a.paddingSM}px clamp(${a.paddingSM}px, 6vw, ${a.paddingLG}px) ${c}`,
        position: o ? "sticky" : "static",
        bottom: o ? 0 : void 0,
        zIndex: o ? a.zIndexPopupBase : void 0
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: a.marginSM,
            minHeight: Ne
          },
          children: [
            /* @__PURE__ */ e("div", { style: { minHeight: 24, flex: 1 }, children: r ? typeof r == "string" ? /* @__PURE__ */ e($.Text, { type: "secondary", children: r }) : r : null }),
            /* @__PURE__ */ d(G, { size: a.marginSM, wrap: !0, children: [
              n?.map((u) => /* @__PURE__ */ e(M, { onClick: u.onClick, children: u.label }, u.label)),
              /* @__PURE__ */ e(
                M,
                {
                  type: "primary",
                  onClick: t.onClick,
                  disabled: t.disabled,
                  loading: t.loading,
                  children: t.label
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, { Footer: yo } = le, Ws = ({
  selectedCount: t = 0,
  bulkActions: n,
  pagination: r,
  extra: o,
  bordered: i = !0
}) => {
  const { token: a } = Z.useToken(), l = a.colorSplit ?? a.colorBorderSecondary, s = a.colorBgContainer, c = t > 0, [u, h] = I(!1), [p, A] = I(-1), C = $e(null), y = $e(null), v = $e([]);
  ie(() => {
    !c && u && h(!1);
  }, [c, u]);
  const w = X(() => n?.length ? n.filter(
    (k) => !!(k?.key && k?.label && typeof k.onClick == "function")
  ) : [], [n]), P = w.length > 0, b = c && P, O = we(() => {
    b && h((k) => !k);
  }, [b]);
  ie(() => {
    if (!u) {
      A(-1);
      return;
    }
    w.length > 0 && (A(0), v.current[0]?.focus());
    const k = (U) => {
      const f = U.target;
      f && (y.current?.contains(f) || C.current?.contains(f) || h(!1));
    }, S = (U) => {
      U.key === "Escape" && (h(!1), C.current?.focus());
    };
    return document.addEventListener("mousedown", k), document.addEventListener("keydown", S), () => {
      document.removeEventListener("mousedown", k), document.removeEventListener("keydown", S);
    };
  }, [u, w.length]);
  const F = we((k) => {
    h(!1), k.onClick();
  }, []), H = we(
    (k, S) => {
      const U = w.length;
      let f = S;
      switch (k.key) {
        case "ArrowDown":
          k.preventDefault(), f = (S + 1) % U;
          break;
        case "ArrowUp":
          k.preventDefault(), f = (S - 1 + U) % U;
          break;
        case "Home":
          k.preventDefault(), f = 0;
          break;
        case "End":
          k.preventDefault(), f = U - 1;
          break;
        case "Tab":
          h(!1);
          return;
        default:
          return;
      }
      A(f), v.current[f]?.focus();
    },
    [w.length]
  );
  return /* @__PURE__ */ e(
    yo,
    {
      style: {
        background: s,
        borderTop: i ? `1px solid ${l}` : void 0,
        padding: `${a.paddingSM}px clamp(${a.paddingSM}px, 5vw, ${a.paddingLG}px)`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: a.marginSM,
            minHeight: Ne
          },
          children: [
            /* @__PURE__ */ d(G, { size: a.marginSM, wrap: !0, children: [
              c ? /* @__PURE__ */ d($.Text, { strong: !0, children: [
                t,
                " selected"
              ] }) : /* @__PURE__ */ e($.Text, { type: "secondary", children: "No rows selected" }),
              P ? /* @__PURE__ */ d("div", { style: { position: "relative" }, children: [
                /* @__PURE__ */ e(
                  M,
                  {
                    ref: C,
                    disabled: !b,
                    onClick: O,
                    "aria-haspopup": "menu",
                    "aria-expanded": b ? u : void 0,
                    children: "Bulk actions"
                  }
                ),
                u ? /* @__PURE__ */ e(
                  "div",
                  {
                    ref: y,
                    role: "menu",
                    "aria-label": "Bulk actions",
                    style: {
                      position: "absolute",
                      top: a.paddingLG,
                      left: 0,
                      background: s,
                      border: `1px solid ${l}`,
                      borderRadius: a.borderRadiusLG,
                      boxShadow: a.boxShadowSecondary,
                      minWidth: 160,
                      zIndex: a.zIndexPopupBase,
                      display: "flex",
                      flexDirection: "column"
                    },
                    children: w.map((k, S) => /* @__PURE__ */ e(
                      "button",
                      {
                        ref: (U) => {
                          v.current[S] = U;
                        },
                        type: "button",
                        role: "menuitem",
                        tabIndex: p === S ? 0 : -1,
                        onClick: () => F(k),
                        onKeyDown: (U) => H(U, S),
                        style: {
                          width: "100%",
                          padding: `${a.paddingXS}px ${a.paddingSM}px`,
                          background: "transparent",
                          border: "none",
                          textAlign: "left",
                          cursor: "pointer"
                        },
                        children: k.label
                      },
                      k.key
                    ))
                  }
                ) : null
              ] }) : null
            ] }),
            /* @__PURE__ */ d(G, { size: a.marginSM, wrap: !0, children: [
              o,
              r
            ] })
          ]
        }
      )
    }
  );
}, { Footer: bo } = le, rn = (t) => t?.name ?? "—", Vs = ({
  org: t,
  site: n,
  region: r,
  locale: o,
  impersonating: i,
  links: a
}) => {
  const { token: l } = Z.useToken();
  return /* @__PURE__ */ e(
    bo,
    {
      style: {
        background: l.colorBgContainer,
        borderTop: `1px solid ${l.colorSplit ?? l.colorBorderSecondary}`,
        padding: `${l.paddingSM}px clamp(${l.paddingSM}px, 5vw, ${l.paddingXL}px)`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: l.marginSM,
            minHeight: Ne
          },
          children: [
            /* @__PURE__ */ d(G, { size: l.marginSM, wrap: !0, children: [
              /* @__PURE__ */ e($.Text, { strong: !0, children: "Org:" }),
              /* @__PURE__ */ e($.Text, { children: rn(t) }),
              /* @__PURE__ */ e($.Text, { strong: !0, children: "Site:" }),
              /* @__PURE__ */ e($.Text, { children: rn(n) }),
              r ? /* @__PURE__ */ e(be, { color: "blue", bordered: !1, children: r.toUpperCase() }) : null,
              o ? /* @__PURE__ */ e(be, { color: "purple", bordered: !1, children: o }) : null
            ] }),
            /* @__PURE__ */ d(G, { size: l.marginSM, wrap: !0, align: "center", children: [
              i ? /* @__PURE__ */ d(be, { color: "orange", bordered: !1, children: [
                "Impersonating ",
                i.name
              ] }) : null,
              a?.map((s) => /* @__PURE__ */ d($.Link, { href: s.href, style: { color: l.colorPrimary }, children: [
                s.icon,
                s.icon ? /* @__PURE__ */ e("span", { style: { marginLeft: 4 }, children: s.label }) : s.label
              ] }, s.href))
            ] })
          ]
        }
      )
    }
  );
}, { Footer: So } = le, wo = {
  ok: "success",
  warn: "warning",
  err: "error"
}, js = ({ metrics: t, legal: n }) => {
  const { token: r } = Z.useToken();
  return /* @__PURE__ */ e(
    So,
    {
      style: {
        background: r.colorBgContainer,
        borderTop: `1px solid ${r.colorSplit ?? r.colorBorderSecondary}`,
        padding: `${r.paddingSM}px clamp(${r.paddingSM}px, 6vw, ${r.paddingXL}px)`
      },
      children: /* @__PURE__ */ d(
        G,
        {
          orientation: "vertical",
          size: r.marginSM,
          style: { width: "100%", minHeight: Ne },
          children: [
            /* @__PURE__ */ e(G, { size: r.marginSM, wrap: !0, children: t.map((o, i) => /* @__PURE__ */ d(
              be,
              {
                color: o.status ? wo[o.status] : void 0,
                bordered: !1,
                style: { paddingInline: r.paddingXS, fontWeight: 500 },
                children: [
                  o.label,
                  ": ",
                  o.value
                ]
              },
              `${o.label}-${i}`
            )) }),
            n ? /* @__PURE__ */ e($.Text, { type: "secondary", style: { fontSize: 12 }, children: n }) : null
          ]
        }
      )
    }
  );
}, { Footer: vo } = le, Gs = ({
  text: t = "© DigiWedge. All rights reserved.",
  links: n,
  align: r = "spread"
}) => {
  const { token: o } = Z.useToken(), i = r === "center" ? "center" : "space-between", a = `clamp(${o.paddingSM}px, 4vw, ${o.paddingLG}px)`, l = `${o.paddingXS}px`;
  return /* @__PURE__ */ e(
    vo,
    {
      style: {
        background: o.colorBgContainer,
        borderTop: `1px solid ${o.colorSplit ?? o.colorBorderSecondary}`,
        padding: `${l} ${a}`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: i,
            alignItems: "center",
            flexWrap: "wrap",
            gap: o.marginSM,
            minHeight: Ne,
            color: o.colorTextDescription ?? o.colorTextSecondary,
            fontSize: 12
          },
          children: [
            /* @__PURE__ */ e($.Text, { type: "secondary", children: t }),
            n?.length ? /* @__PURE__ */ e(G, { size: o.marginSM, wrap: !0, children: n.map((s) => /* @__PURE__ */ e($.Link, { href: s.href, style: { color: o.colorPrimary }, children: s.label }, s.href)) }) : null
          ]
        }
      )
    }
  );
};
function ko({
  navItems: t,
  selectedNavKey: n,
  isTestEnv: r,
  onNavigate: o
}) {
  const i = z.useMemo(() => t ?? [], [t]), a = z.useMemo(() => Dn(i), [i]), l = i.some(Boolean);
  return /* @__PURE__ */ d(ye, { children: [
    l ? /* @__PURE__ */ e(
      xn,
      {
        mode: "horizontal",
        items: i,
        selectedKeys: n ? [n] : [],
        onClick: ({ key: s }) => o(s),
        style: {
          flex: 1,
          minWidth: 0,
          background: "transparent",
          borderBottom: "none"
        }
      }
    ) : /* @__PURE__ */ e("div", { style: { flex: 1, minWidth: 0 } }),
    r && a.length ? /* @__PURE__ */ e("ul", { style: Co, "aria-hidden": !0, children: a.map((s) => /* @__PURE__ */ e("li", { children: s.label }, s.key)) }) : null
  ] });
}
const Co = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
};
function Dn(t) {
  if (!t?.length)
    return [];
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      continue;
    const o = "key" in r && r.key != null ? String(r.key) : void 0, i = "label" in r ? r.label : void 0;
    typeof i == "string" && n.push({ key: o ?? i, label: i }), "children" in r && Array.isArray(r.children) && n.push(...Dn(r.children));
  }
  return n;
}
function xo({
  onNavigate: t,
  token: n,
  user: r,
  userMenuItems: o,
  userProfilePath: i
}) {
  const a = z.useMemo(() => Ao(o), [o]), l = a.items, s = a.autoNavigateKeys, c = l.length > 0, u = i?.trim(), h = !!u, p = z.useRef(null), A = z.useRef(null), [C, y] = z.useState(!1), v = z.useCallback(() => {
    const S = p.current;
    S && typeof S.focus == "function" && S.focus();
  }, []), w = z.useCallback(
    (S) => {
      y(!1), S?.restoreFocus && requestAnimationFrame(() => {
        v();
      });
    },
    [v]
  ), P = z.useCallback(() => {
    c && y((S) => !S);
  }, [c]), b = z.useCallback(
    (S) => {
      if (!c) {
        u && (S.key === "Enter" || S.key === " ") && (S.preventDefault(), t(u));
        return;
      }
      (S.key === "Enter" || S.key === " ") && (S.preventDefault(), P());
    },
    [c, t, u, P]
  ), O = z.useCallback(
    (S) => {
      const U = S.target;
      if (!c && u && U?.closest("[data-user-profile-trigger]")) {
        S.preventDefault(), w(), t(u);
        return;
      }
      c && P();
    },
    [w, c, t, u, P]
  ), F = z.useCallback(
    (S, U) => {
      if (w(), !S || typeof S != "object" || !("key" in S) || S.key == null)
        return;
      const f = String(S.key);
      if ("onClick" in S && typeof S.onClick == "function") {
        const E = {
          key: f,
          keyPath: [f],
          item: U.currentTarget,
          domEvent: U
        };
        S.onClick(E);
      }
      U.defaultPrevented || !s.has(f) || t(f);
    },
    [w, t, s]
  );
  z.useEffect(() => {
    if (!C)
      return;
    const S = (U) => {
      const f = U.target;
      f && (A.current?.contains(f) || p.current?.contains(f) || w());
    };
    return document.addEventListener("mousedown", S), () => {
      document.removeEventListener("mousedown", S);
    };
  }, [w, C]), z.useEffect(() => {
    if (!C)
      return;
    const S = (U) => {
      U.key === "Escape" && (U.preventDefault(), w({ restoreFocus: !0 }));
    };
    return document.addEventListener("keydown", S), () => {
      document.removeEventListener("keydown", S);
    };
  }, [w, C]);
  const H = r.avatarUrl ? "transparent" : "#4caf50", k = r.name[0]?.toUpperCase() ?? "UNK";
  return /* @__PURE__ */ d("div", { style: { position: "relative" }, children: [
    /* @__PURE__ */ d(
      G,
      {
        ref: p,
        onClick: O,
        onKeyDown: b,
        role: "button",
        tabIndex: c || h ? 0 : -1,
        "aria-label": "User menu trigger",
        "aria-haspopup": "menu",
        "aria-expanded": c ? C : void 0,
        style: {
          cursor: c || h ? "pointer" : "default",
          alignItems: "center"
        },
        children: [
          /* @__PURE__ */ e(
            _n,
            {
              "data-user-profile-trigger": h ? "true" : void 0,
              src: r.avatarUrl,
              style: {
                backgroundColor: H,
                border: `2px solid ${n.colorPrimary}`
              },
              "aria-label": "User menu",
              children: k
            }
          ),
          /* @__PURE__ */ e(vr, { style: { fontSize: 12, color: n.colorText } })
        ]
      }
    ),
    C ? /* @__PURE__ */ e(
      _o,
      {
        items: l,
        menuRef: A,
        onItemClick: F,
        token: n
      }
    ) : null
  ] });
}
function _o({
  items: t,
  menuRef: n,
  onItemClick: r,
  token: o
}) {
  return /* @__PURE__ */ e(
    "div",
    {
      ref: n,
      role: "menu",
      "aria-label": "User actions",
      style: {
        position: "absolute",
        top: "calc(100% + 4px)",
        right: 0,
        background: o.colorBgElevated,
        border: `1px solid ${o.colorBorder}`,
        borderRadius: o.borderRadiusLG,
        boxShadow: o.boxShadowSecondary,
        minWidth: 180,
        zIndex: o.zIndexPopupBase,
        overflow: "hidden"
      },
      children: /* @__PURE__ */ e("ul", { role: "none", style: { listStyle: "none", margin: 0, padding: 4 }, children: t.map((i) => To(i, r, o)) })
    }
  );
}
function To(t, n, r) {
  if (!t || typeof t != "object" || !("key" in t))
    return null;
  const o = String(t.key), i = "label" in t ? t.label : o, a = "disabled" in t && t.disabled === !0;
  return /* @__PURE__ */ e("li", { role: "none", children: /* @__PURE__ */ e(
    "button",
    {
      type: "button",
      role: "menuitem",
      disabled: a,
      onClick: (l) => n(t, l),
      style: {
        width: "100%",
        border: 0,
        background: "transparent",
        color: r.colorText,
        cursor: a ? "not-allowed" : "pointer",
        font: "inherit",
        padding: "8px 12px",
        textAlign: "left"
      },
      children: i
    }
  ) }, o);
}
function Ao(t) {
  if (!t?.length)
    return { items: [], autoNavigateKeys: /* @__PURE__ */ new Set() };
  const n = [], r = /* @__PURE__ */ new Set();
  for (const o of t) {
    if (!o || typeof o != "object" || !("key" in o) || o.key == null || !("label" in o))
      continue;
    const i = o.label;
    if (i == null)
      continue;
    const a = String(o.key), l = { ...o, key: a, label: i }, s = "onClick" in o && typeof o.onClick == "function";
    n.push(l), !z.isValidElement(i) && !s && r.add(a);
  }
  return { items: n, autoNavigateKeys: r };
}
function No({
  user: t,
  userMenuItems: n,
  notificationsCount: r,
  notificationsPath: o,
  rightExtra: i,
  buttonColor: a,
  userProfilePath: l,
  token: s,
  onNavigate: c
}) {
  return /* @__PURE__ */ d(G, { size: "middle", style: { marginLeft: "auto", display: "flex", alignItems: "center" }, children: [
    i,
    t?.name ? /* @__PURE__ */ e(
      Lo,
      {
        user: t,
        userMenuItems: n,
        notificationsCount: r,
        notificationsPath: o,
        rightExtra: i,
        buttonColor: a,
        userProfilePath: l,
        token: s,
        onNavigate: c
      }
    ) : /* @__PURE__ */ e(Do, { buttonColor: a, token: s, onNavigate: c })
  ] });
}
function Lo({
  user: t,
  userMenuItems: n,
  notificationsCount: r,
  notificationsPath: o,
  rightExtra: i,
  buttonColor: a,
  userProfilePath: l,
  token: s,
  onNavigate: c
}) {
  const u = !i && r !== void 0 ? Io(o) : void 0;
  return /* @__PURE__ */ d(ye, { children: [
    u !== void 0 ? /* @__PURE__ */ e(
      dr,
      {
        count: r,
        "aria-label": `${r} notifications`,
        style: { alignSelf: "center" },
        children: /* @__PURE__ */ e(
          M,
          {
            type: "text",
            icon: /* @__PURE__ */ e(kr, { style: { width: 18, height: 18 } }),
            "aria-label": "Notifications",
            onClick: () => c(u),
            style: {
              color: s.colorText,
              ...a ? { background: a, borderColor: a, color: "#fff" } : {}
            }
          }
        )
      }
    ) : null,
    /* @__PURE__ */ e(
      xo,
      {
        onNavigate: c,
        token: s,
        user: t,
        userMenuItems: n,
        userProfilePath: l
      }
    )
  ] });
}
function Io(t) {
  const n = t?.trim();
  if (!(!n || !n.startsWith("/") || n.startsWith("//")))
    return n;
}
function Do({
  buttonColor: t,
  token: n,
  onNavigate: r
}) {
  return /* @__PURE__ */ d(ye, { children: [
    /* @__PURE__ */ e(
      M,
      {
        type: "link",
        onClick: () => r("/login"),
        className: `header-login-button ${t ? "custom-color" : ""}`,
        style: t ? { color: t } : { color: n.colorPrimary },
        children: "Login"
      }
    ),
    /* @__PURE__ */ e(
      M,
      {
        type: "primary",
        onClick: () => r("/signup"),
        style: t ? { background: t, borderColor: t, color: "#fff" } : {
          background: n.colorPrimary,
          borderColor: n.colorPrimary,
          color: "#fff"
        },
        children: "Sign Up"
      }
    )
  ] });
}
const { Header: Po } = le, Ys = ({
  navItems: t,
  userMenuItems: n,
  notificationsCount: r,
  notificationsPath: o,
  user: i,
  selectedNavKey: a,
  borderColor: l,
  buttonColor: s,
  leftExtra: c,
  rightExtra: u,
  className: h,
  style: p,
  themeMode: A,
  userProfilePath: C
}) => {
  const y = ct(), { token: v } = Z.useToken(), w = process.env.NODE_ENV === "test";
  return /* @__PURE__ */ e(
    Po,
    {
      className: h,
      style: {
        display: "flex",
        alignItems: "center",
        padding: 0,
        transition: "background 0.3s ease",
        borderBottom: `1px solid ${l || v.colorSplit || "#e0e0e0"}`,
        backgroundColor: v.colorBgContainer,
        ...p
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "0 16px"
          },
          children: [
            c,
            /* @__PURE__ */ e(
              ko,
              {
                isTestEnv: w,
                navItems: t,
                onNavigate: y,
                selectedNavKey: a
              }
            ),
            /* @__PURE__ */ e(
              No,
              {
                buttonColor: s,
                notificationsCount: r,
                notificationsPath: o,
                onNavigate: y,
                rightExtra: u,
                token: v,
                user: i,
                userMenuItems: n,
                userProfilePath: C
              }
            )
          ]
        }
      )
    }
  );
}, Pn = z.memo(
  ({
    themeMode: t = "light",
    size: n = "medium",
    // Defaults align visually with theme: light => light bg, dark => dark bg
    lightLogoSrc: r = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="48"><rect width="150" height="48" fill="%23ffffff"/><text x="75" y="30" font-size="14" text-anchor="middle" fill="%23000000">Light Logo</text></svg>',
    darkLogoSrc: o = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="48"><rect width="150" height="48" fill="%23000000"/><text x="75" y="30" font-size="14" text-anchor="middle" fill="%23ffffff">Dark Logo</text></svg>',
    style: i,
    alt: a
  }) => /* @__PURE__ */ e(
    "img",
    {
      src: t === "dark" ? o : r,
      alt: a ?? `${t === "dark" ? "Dark" : "Light"} Mode Logo`,
      style: {
        ...{
          small: { height: "24px", width: "auto" },
          medium: { height: "48px", width: "auto" },
          large: { height: "72px", width: "auto" }
        }[n],
        ...i
      }
    }
  )
), Uo = 64;
function Eo(t = Uo) {
  return {
    height: `calc(100vh - ${t}px)`,
    maxHeight: `calc(100vh - ${t}px)`,
    position: "sticky",
    top: t,
    alignSelf: "flex-start"
  };
}
const { useBreakpoint: Mo } = xt, { Sider: Ro } = le, { Text: Bo } = $, Ks = ({
  collapsed: t,
  onCollapse: n,
  collapsible: r = !0,
  themeMode: o = "light",
  sidebarItems: i,
  onClick: a,
  selectedKeys: l,
  defaultSelectedKeys: s,
  openKeys: c,
  onOpenChange: u,
  defaultOpenKeys: h = [],
  logo: p,
  style: A,
  className: C,
  menuClassName: y,
  menuStyle: v,
  breakpoint: w = "md",
  width: P = 240,
  collapsedWidth: b = 80,
  testId: O
}) => {
  const { token: F } = Z.useToken(), H = Mo(), k = z.useRef(void 0), S = process.env.NODE_ENV === "test";
  z.useEffect(() => {
    const Q = H[w];
    r && k.current !== void 0 && k.current !== Q && n?.(!Q), k.current = Q;
  }, [H, w, r, n]);
  const U = z.useCallback(() => {
    n?.(!t);
  }, [t, n]), f = z.useMemo(() => Un(i), [i]), E = ["digiwedge-sidebar", C].filter(Boolean).join(" "), L = ["digiwedge-sidebar-menu", y].filter(Boolean).join(" "), j = z.useMemo(
    () => ({
      inherit: !0,
      components: {
        Menu: Ur(o)
      }
    }),
    [o]
  ), B = z.useMemo(
    () => ({
      theme: o,
      mode: "inline",
      items: i,
      onClick: a,
      selectedKeys: l,
      defaultSelectedKeys: s,
      openKeys: c,
      onOpenChange: u,
      defaultOpenKeys: h,
      className: L,
      style: {
        flex: "1 1 auto",
        minHeight: 0,
        overflowX: "hidden",
        overflowY: "auto",
        ...v
      }
    }),
    [
      o,
      i,
      a,
      l,
      s,
      c,
      u,
      h,
      L,
      v
    ]
  );
  return /* @__PURE__ */ e(kn, { theme: j, children: /* @__PURE__ */ d(
    Ro,
    {
      collapsible: r,
      collapsed: t,
      theme: o,
      trigger: null,
      width: P,
      collapsedWidth: b,
      "data-testid": O,
      style: {
        // Backward-compatible default geometry: a sticky, viewport-bounded shell so that
        // wrapper consumers which do NOT pass `style` (e.g. MessagingSidebar / messaging-admin)
        // keep their sticky scroll behavior. App shells that own their geometry override this
        // via the `style` prop, which is spread last. See #19560.
        ...Eo(),
        minHeight: 0,
        overflow: "hidden",
        // Use token to dynamically adjust the background per theme
        background: F.colorBgContainer,
        paddingBottom: F.paddingLG,
        ...A
      },
      className: E,
      children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: "digiwedge-sidebar-logo",
            style: {
              padding: F.padding,
              borderBottom: `1px solid ${F.colorBorder}`
            },
            children: p || /* @__PURE__ */ e(Bo, { strong: !0, children: t ? "Logo" : "Application Name" })
          }
        ),
        /* @__PURE__ */ e(xn, { ...B }),
        S && f.length ? /* @__PURE__ */ e("ul", { style: Fo, "aria-hidden": !0, children: f.map((Q) => /* @__PURE__ */ e("li", { children: Q.label }, Q.key)) }) : null,
        r ? /* @__PURE__ */ e(
          M,
          {
            type: "text",
            onClick: U,
            icon: t ? /* @__PURE__ */ e(Cr, {}) : /* @__PURE__ */ e(xr, {}),
            className: "digiwedge-sidebar-toggle",
            style: {
              width: "100%",
              borderRadius: 0,
              borderTop: `1px solid ${F.colorBorder}`
            },
            "aria-label": t ? "Expand sidebar" : "Collapse sidebar"
          }
        ) : null
      ]
    }
  ) });
}, Fo = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
};
function Un(t) {
  if (!t?.length)
    return [];
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      continue;
    const o = "key" in r && r.key != null ? String(r.key) : void 0, i = "label" in r ? r.label : void 0;
    typeof i == "string" && n.push({ key: o ?? i, label: i }), "children" in r && Array.isArray(r.children) && n.push(...Un(r.children));
  }
  return n;
}
function Fe(t, n) {
  const r = n ? new Set(n) : void 0, o = [];
  for (const i of t)
    r && !r.has(i) || o.includes(i) || o.push(i);
  return o;
}
function on(t, n) {
  if (typeof window > "u")
    return { found: !1, hadNonStringEntries: !1, hadPersistedEntries: !1, keys: [] };
  try {
    const r = window.localStorage.getItem(t);
    if (!r)
      return { found: !1, hadNonStringEntries: !1, hadPersistedEntries: !1, keys: [] };
    const o = JSON.parse(r);
    if (!Array.isArray(o))
      return { found: !1, hadNonStringEntries: !1, hadPersistedEntries: !1, keys: [] };
    const i = o.filter((a) => typeof a == "string");
    return {
      found: !0,
      hadNonStringEntries: i.length !== o.length,
      hadPersistedEntries: o.length > 0,
      keys: Fe(i, n)
    };
  } catch {
    return { found: !1, hadNonStringEntries: !1, hadPersistedEntries: !1, keys: [] };
  }
}
function an(t, n) {
  if (!(typeof window > "u"))
    try {
      window.localStorage.setItem(t, JSON.stringify(n));
    } catch {
    }
}
function sn(t, n) {
  return t.length === n.length && t.every((r, o) => r === n[o]);
}
function Qs({
  storageKey: t,
  defaultOpenKeys: n,
  validOpenKeys: r
}) {
  const [o, i] = z.useState(() => {
    const l = on(t, r), s = Fe(n, r);
    return l.found ? l.hadPersistedEntries && l.keys.length === 0 ? s : l.keys : s;
  });
  z.useEffect(() => {
    i((s) => {
      const c = Fe(s, r);
      return sn(s, c) ? s : c;
    });
    const l = on(t, void 0);
    if (l.found) {
      const s = Fe(n, r), c = Fe(l.keys, r), u = l.hadPersistedEntries && c.length === 0 ? s : c;
      (l.hadNonStringEntries || !sn(l.keys, u)) && an(t, u);
    }
  }, [n, t, r]);
  const a = z.useCallback(
    (l) => {
      const s = Fe(l, r);
      i(s), an(t, s);
    },
    [t, r]
  );
  return [o, a];
}
const $o = {
  DRAFT: "default",
  POSTED: "processing",
  PAID: "success",
  OVERDUE: "error",
  VOID: "warning",
  ISSUED: "default",
  SENT: "default",
  PART_PAID: "default",
  REFUNDED: "default"
}, st = ({ status: t }) => /* @__PURE__ */ e(be, { color: $o[t], className: "px-2 text-xs font-medium", children: t }), Xs = ({ label: t, color: n, closable: r = !1, onClose: o }) => /* @__PURE__ */ e(be, { color: n, closable: r, onClose: o, className: "px-2 text-xs font-medium", children: t }), { Text: Oo } = $, Nt = (t, n = "ZAR", r = !0, o) => {
  const i = o ?? (typeof navigator < "u" ? navigator.language : "en-US"), a = Number(t), l = Math.abs(a), s = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }, u = new Intl.NumberFormat(i, {
    ...s,
    style: r ? "currency" : "decimal",
    currency: n,
    currencyDisplay: "narrowSymbol"
  }).format(l), h = r ? u : `${u} ${n}`;
  return `${a < 0 ? "−" : ""}${h}`;
}, he = ({
  amount: t,
  currency: n = "ZAR",
  showSymbol: r = !0,
  className: o
}) => {
  const a = Number(t) < 0, l = Nt(t, n, r);
  return /* @__PURE__ */ e(Oo, { className: o, type: a ? "danger" : void 0, strong: a, children: l });
};
te.extend(Rr);
te.extend(Mr);
te.extend($r);
te.extend(Fr);
te.extend(Or);
te.extend(qr);
te.extend(Br);
const { RangePicker: qo } = Tn, zo = () => {
  const t = te(), n = t.startOf("week"), r = t.endOf("week"), o = t.startOf("month"), i = t.endOf("month"), a = t.month(), l = t.year(), s = a >= 6 ? te(`${l}-07-01`) : te(`${l - 1}-07-01`), c = s.add(1, "year").subtract(1, "day");
  return [
    { label: "📅 Today", value: [t, t] },
    {
      label: "📅 This Week",
      value: [n, r]
    },
    {
      label: "📅 This Month",
      value: [o, i]
    },
    { label: "📅 Financial Year", value: [s, c] }
  ];
}, En = ({
  value: t,
  onChange: n,
  presets: r = !0,
  allowClear: o = !1,
  disabled: i,
  className: a,
  open: l,
  "data-testid": s
}) => {
  const [c, u] = I([
    t?.[0] ?? null,
    t?.[1] ?? null
  ]);
  ie(() => {
    t && u(t);
  }, [t]);
  const h = (C, y) => {
    const w = ((P) => !!P && typeof P == "object" && "range" in P && P.range !== void 0)(y) ? y.range : void 0;
    return w === "start" && c[1] ? C.isAfter(c[1], "day") : w === "end" && c[0] ? C.isBefore(c[0], "day") : !1;
  };
  return /* @__PURE__ */ e(
    qo,
    {
      value: t ?? c,
      onCalendarChange: (C) => {
        u([C?.[0] ?? null, C?.[1] ?? null]);
      },
      onChange: (C) => {
        if (!C) {
          o && (u([null, null]), n?.([null, null]));
          return;
        }
        let [y, v] = [C[0] ?? null, C[1] ?? null];
        y && v ? (y.isAfter(v) && ([y, v] = [v, y]), u([y, v]), n?.([y, v])) : o && (u([y ?? null, v ?? null]), n?.([y ?? null, v ?? null]));
      },
      presets: r ? zo() : void 0,
      allowClear: o,
      disabled: i,
      className: a,
      disabledDate: h,
      open: l,
      "data-testid": s
    }
  );
}, Ho = ({
  x: t,
  y: n,
  width: r,
  height: o,
  payload: i,
  patternId: a,
  colorMap: l,
  onEdit: s,
  highlightColor: c,
  activeId: u,
  setActiveId: h,
  formatDate: p
}) => {
  if (!i || typeof t != "number" || typeof n != "number" || typeof r != "number" || typeof o != "number")
    return null;
  const A = o * 0.6, C = n + (o - A) / 2, y = i.status === "OVERLAP" ? `url(#${a})` : l[i.status], v = /* @__PURE__ */ e(
    "rect",
    {
      x: t,
      y: C,
      width: r,
      height: A,
      fill: y,
      stroke: u === i.id ? c : void 0,
      strokeWidth: u === i.id ? 2 : 0,
      "data-testid": `bar-${i.id}`
    }
  );
  return s ? /* @__PURE__ */ e("foreignObject", { x: t, y: n, width: r, height: o, children: /* @__PURE__ */ e(
    "button",
    {
      style: {
        width: "100%",
        height: "100%",
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        position: "relative"
      },
      "aria-label": `${i.itemName} ${Nt(i.price, i.currency)} ${p(new Date(i.from))} - ${p(new Date(i.to))} ${i.status}`,
      onClick: () => s(i.id),
      onMouseEnter: () => h(i.id),
      onMouseLeave: () => h(null),
      onFocus: () => h(i.id),
      onBlur: () => h(null),
      children: /* @__PURE__ */ e("svg", { width: "100%", height: "100%", style: { position: "absolute", top: 0, left: 0 }, children: v })
    }
  ) }) : v;
}, Zs = ({
  schedules: t,
  onEdit: n,
  height: r = 60,
  className: o,
  showLegend: i = !1,
  groupBySeason: a = !1,
  locale: l,
  dateFormatter: s
}) => {
  const { token: c } = Z.useToken(), u = ar(), [h, p] = I(null), A = we(
    (f) => s ? s(f) : f.toLocaleDateString(l),
    [s, l]
  ), { data: C, domain: y, domainStart: v } = X(() => {
    if (t.length === 0)
      return {
        data: [],
        domain: [0, 1],
        domainStart: 0
      };
    const f = [...t].sort(
      (re, Ie) => new Date(re.from).getTime() - new Date(Ie.from).getTime()
    ), E = f.map((re) => new Date(re.from).getTime()), L = f.map((re) => new Date(re.to).getTime()), j = Math.min(...E), B = Math.max(...L), Y = (B - j || 1) * 0.05, ue = j - Y, se = B + Y;
    return {
      data: f.map((re) => ({
        ...re,
        offset: new Date(re.from).getTime() - ue,
        duration: new Date(re.to).getTime() - new Date(re.from).getTime()
      })),
      domain: [0, se - ue],
      domainStart: ue
    };
  }, [t]), w = v + y[1], P = X(() => {
    const f = (w - v) / 4;
    return Array.from({ length: 5 }, (E, L) => L * f);
  }, [w, v]), b = Date.now() - v, O = b >= 0 && b <= y[1], F = X(
    () => ({
      ACTIVE: c.colorSuccess,
      FUTURE: c.colorInfo,
      EXPIRED: c.colorTextDisabled,
      OVERLAP: c.colorError
    }),
    [c]
  ), H = X(() => {
    if (!a)
      return [];
    const f = /* @__PURE__ */ new Map();
    return C.forEach((E) => {
      const L = new Date(E.from).getFullYear().toString(), j = E.offset, B = E.offset + E.duration, Q = f.get(L);
      Q ? (Q.start = Math.min(Q.start, j), Q.end = Math.max(Q.end, B)) : f.set(L, { start: j, end: B });
    }), Array.from(f.entries()).map(([E, L]) => ({
      season: E,
      start: L.start,
      end: L.end
    }));
  }, [a, C]), k = we(
    (f) => /* @__PURE__ */ e(
      Ho,
      {
        ...f,
        patternId: u,
        colorMap: F,
        onEdit: n,
        highlightColor: c.colorPrimaryHover,
        activeId: h,
        setActiveId: p,
        formatDate: A
      }
    ),
    [u, F, n, h, p, c.colorPrimaryHover, A]
  );
  if (t.length === 0)
    return /* @__PURE__ */ e(ur, { className: o });
  const S = t.some((f) => f.status === "OVERLAP"), U = ({ active: f, payload: E }) => {
    if (f && E?.length) {
      const L = E[0].payload, j = new Date(L.from).getFullYear().toString();
      return /* @__PURE__ */ d("div", { style: { padding: 8 }, children: [
        a && /* @__PURE__ */ d("div", { style: { fontStyle: "italic" }, children: [
          "Season ",
          j
        ] }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("strong", { children: L.itemName }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(he, { amount: L.price, currency: L.currency }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ d("span", { children: [
          A(new Date(L.from)),
          " - ",
          A(new Date(L.to))
        ] }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(st, { status: ln(L.status) }) })
      ] });
    }
    return null;
  };
  return /* @__PURE__ */ d("div", { className: o, style: { width: "100%", height: r }, children: [
    S && /* @__PURE__ */ e(st, { status: ln("OVERLAP") }),
    /* @__PURE__ */ e(zr, { width: "100%", height: "100%", children: /* @__PURE__ */ d(Hr, { data: C, margin: { top: 0, right: 0, left: 0, bottom: 0 }, barCategoryGap: 0, children: [
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ d(
        "pattern",
        {
          id: u,
          patternUnits: "userSpaceOnUse",
          width: 8,
          height: 8,
          patternTransform: "rotate(45)",
          children: [
            /* @__PURE__ */ e("rect", { x: "0", y: "0", width: "8", height: "8", fill: c.colorErrorBg }),
            /* @__PURE__ */ e("line", { x1: "0", y1: "0", x2: "0", y2: "8", stroke: c.colorError, strokeWidth: "2" })
          ]
        }
      ) }),
      /* @__PURE__ */ e(
        Wr,
        {
          dataKey: "offset",
          type: "number",
          domain: y,
          ticks: P,
          tickFormatter: (f) => A(new Date(v + f)),
          tick: { fontSize: 10 }
        }
      ),
      /* @__PURE__ */ e(Vr, { hide: !0 }),
      /* @__PURE__ */ e(jr, { content: U }),
      a && H.map((f) => /* @__PURE__ */ e(
        Zt,
        {
          x: (f.start + f.end) / 2,
          stroke: "none",
          label: { position: "top", value: f.season, fontSize: 10 }
        },
        f.season
      )),
      O && /* @__PURE__ */ e(
        Zt,
        {
          x: b,
          stroke: c.colorWarning,
          strokeDasharray: "3 3",
          label: { position: "top", value: "Today", fontSize: 10 }
        }
      ),
      /* @__PURE__ */ e(
        Gr,
        {
          dataKey: "duration",
          minPointSize: 2,
          isAnimationActive: !1,
          shape: k
        }
      )
    ] }) }),
    i && /* @__PURE__ */ e(
      "section",
      {
        className: "mt-1 flex flex-wrap gap-2 text-xs",
        "data-testid": "legend",
        "aria-label": "Chart legend",
        children: Object.entries(F).map(
          ([f, E]) => /* @__PURE__ */ d("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "inline-block w-3 h-3 rounded-sm border",
                style: { backgroundColor: E, borderColor: E },
                "data-testid": `legend-swatch-${f}`
              }
            ),
            /* @__PURE__ */ e("span", { children: f })
          ] }, f)
        )
      }
    )
  ] });
};
function ln(t) {
  switch (t) {
    case "ACTIVE":
      return "ISSUED";
    case "FUTURE":
      return "DRAFT";
    case "EXPIRED":
      return "VOID";
    case "OVERLAP":
      return "OVERDUE";
    default:
      return "DRAFT";
  }
}
const Mn = (t) => /* @__PURE__ */ e(mr, { destroyOnClose: !0, ...t }), Js = ({
  open: t,
  items: n,
  existing: r,
  onCreate: o,
  onClose: i,
  drawerWidth: a = 500
}) => {
  const { message: l } = xe.useApp(), [s, c] = I(0), [u, h] = I(), [p, A] = I(null), [C, y] = I(0), [v, w] = I("ZAR"), [P, b] = I(!1);
  ie(() => {
    t || (c(0), h(void 0), A(null), y(0), w("ZAR"), b(!1));
  }, [t]);
  const O = n.find((L) => L.id === u), F = p ? p[0].isAfter(p[1]) : !1, k = (() => {
    if (!p || !O) return !1;
    const [L, j] = p;
    return r.filter((B) => B.itemName === O.name).some((B) => {
      const Q = te(B.from), Y = te(B.to);
      return !Q.isAfter(j) && !Y.isBefore(L);
    });
  })(), S = !!u, U = !!p && !F && !k, f = async () => {
    if (!(!O || !p)) {
      b(!0);
      try {
        const [L, j] = p, B = {
          itemName: O.name,
          from: L.toISOString(),
          to: j.toISOString(),
          price: C,
          currency: v,
          id: "",
          status: "FUTURE"
        };
        await Promise.resolve(o(B)), i();
      } catch (L) {
        l.error(m("en-US", "createError")), console.error(L);
      } finally {
        b(!1);
      }
    }
  }, E = [
    /* @__PURE__ */ e(Wo, { items: n, itemId: u, onChange: h }, "step1"),
    /* @__PURE__ */ e(
      Vo,
      {
        dates: p,
        onChange: (L) => A(L),
        rangeInvalid: F,
        overlap: k
      },
      "step2"
    ),
    /* @__PURE__ */ e(
      jo,
      {
        item: O?.name ?? "",
        dates: p,
        price: C,
        currency: v,
        onPriceChange: y,
        onCurrencyChange: w
      },
      "step3"
    ),
    /* @__PURE__ */ e(
      Go,
      {
        item: O?.name ?? "",
        dates: p,
        price: C,
        currency: v
      },
      "review"
    )
  ];
  return /* @__PURE__ */ d(Mn, { open: t, onClose: i, size: a, children: [
    /* @__PURE__ */ e(
      _t,
      {
        current: s,
        style: { marginBottom: 24 },
        items: [
          { title: m("en-US", "itemLabel") },
          { title: m("en-US", "dateRangeLabel") },
          { title: m("en-US", "priceLabel") },
          { title: m("en-US", "reviewLabel") }
        ]
      }
    ),
    E[s],
    /* @__PURE__ */ d(G, { style: { marginTop: 24 }, children: [
      s > 0 && /* @__PURE__ */ e(M, { onClick: () => c(s - 1), children: m("en-US", "backAction") }),
      /* @__PURE__ */ d(G, { style: { marginLeft: "auto" }, children: [
        s < 3 && /* @__PURE__ */ e(
          M,
          {
            type: "primary",
            onClick: () => c(s + 1),
            disabled: s === 0 ? !S : s === 1 ? !U : !1,
            children: m("en-US", "nextAction")
          }
        ),
        s === 3 && /* @__PURE__ */ e(
          M,
          {
            type: "primary",
            onClick: f,
            "data-testid": "create-btn",
            loading: P,
            children: m("en-US", "createAction")
          }
        ),
        /* @__PURE__ */ e(M, { onClick: i, children: m("en-US", "cancelAction") })
      ] })
    ] })
  ] });
}, Wo = ({ items: t, itemId: n, onChange: r }) => /* @__PURE__ */ e(_, { layout: "vertical", children: /* @__PURE__ */ e(_.Item, { label: m("en-US", "itemLabel"), required: !0, children: /* @__PURE__ */ e(
  Xe,
  {
    showSearch: !0,
    placeholder: m("en-US", "selectItem"),
    optionFilterProp: "label",
    style: { width: "100%" },
    value: n,
    onChange: r,
    options: t.map((o) => ({ value: o.id, label: o.name }))
  }
) }) }), Vo = ({ dates: t, onChange: n, rangeInvalid: r, overlap: o }) => {
  const i = te();
  return /* @__PURE__ */ e(_, { layout: "vertical", children: /* @__PURE__ */ e(
    _.Item,
    {
      label: m("en-US", "dateRangeLabel"),
      validateStatus: r || o ? "error" : "",
      help: r ? m("en-US", "startBeforeEnd") : o ? m("en-US", "scheduleOverlap") : void 0,
      children: /* @__PURE__ */ d(G, { orientation: "vertical", style: { width: "100%" }, size: "middle", children: [
        /* @__PURE__ */ e(G, { size: "small", children: /* @__PURE__ */ d(M, { type: "link", onClick: () => n([i, i]), children: [
          /* @__PURE__ */ e("span", { role: "img", "aria-label": "calendar", children: "📅" }),
          " ",
          m("en-US", "today")
        ] }) }),
        /* @__PURE__ */ e(En, { value: t ?? void 0, onChange: n })
      ] })
    }
  ) });
}, jo = ({
  item: t,
  dates: n,
  price: r,
  currency: o,
  onPriceChange: i,
  onCurrencyChange: a
}) => /* @__PURE__ */ d(_, { layout: "vertical", children: [
  /* @__PURE__ */ d($.Text, { children: [
    t,
    " — ",
    n ? `${n[0].format("YYYY-MM-DD")} - ${n[1].format("YYYY-MM-DD")}` : ""
  ] }),
  /* @__PURE__ */ e(_.Item, { label: m("en-US", "priceLabel"), children: /* @__PURE__ */ e(
    Tt,
    {
      value: r,
      onChange: (l) => i(l != null ? Number(l) : 0),
      min: 0,
      style: { width: "100%" }
    }
  ) }),
  /* @__PURE__ */ e(_.Item, { label: m("en-US", "currencyLabel"), children: /* @__PURE__ */ e(
    Xe,
    {
      value: o,
      onChange: a,
      options: [
        { value: "ZAR", label: "ZAR" },
        { value: "USD", label: "USD" },
        { value: "EUR", label: "EUR" }
      ]
    }
  ) }),
  /* @__PURE__ */ e(he, { amount: r, currency: o })
] }), Go = ({ item: t, dates: n, price: r, currency: o }) => /* @__PURE__ */ d(G, { orientation: "vertical", style: { width: "100%" }, size: "middle", children: [
  /* @__PURE__ */ e($.Text, { strong: !0, children: t }),
  /* @__PURE__ */ e($.Text, { children: n ? `${n[0].format("YYYY-MM-DD")} - ${n[1].format("YYYY-MM-DD")}` : "" }),
  /* @__PURE__ */ e(he, { amount: r, currency: o })
] }), Yo = "startBeforeEnd", Ko = "scheduleOverlap", cn = (t, n, r) => n && t.isAfter(n) ? Yo : r(t, n) ? Ko : null, Qo = [
  { label: "ZAR", value: "ZAR" },
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" }
], Xo = Yr.string().length(3, "Invalid currency code").regex(/^[A-Za-z]{3}$/, "Invalid currency code").transform((t) => t.toUpperCase()), el = ({
  visible: t,
  schedule: n,
  otherSchedules: r,
  onSave: o,
  onCancel: i,
  onDelete: a
}) => {
  const [l] = _.useForm(), [s, c] = I(null);
  ie(() => {
    t && l.setFieldsValue({
      itemName: n.itemName,
      range: [te(n.from), n.to ? te(n.to) : null],
      price: n.price,
      currency: n.currency ?? "ZAR"
    });
  }, [t, n, l]);
  const u = (y, v) => r?.length ? r.some((w) => {
    if (w.id === n.id) return !1;
    const P = te(w.from), b = w.to ? te(w.to) : null, O = !b || y.isBefore(b) || y.isSame(b), F = !v || P.isBefore(v) || P.isSame(v);
    return O && F;
  }) : !1, h = () => {
    const [y, v] = l.getFieldValue("range");
    if (!y || v === void 0) {
      c(null);
      return;
    }
    c(cn(y, v, u));
  }, p = async () => {
    try {
      const y = await l.validateFields(), [v, w] = y.range, P = cn(v, w, u);
      if (P) {
        c(P);
        return;
      }
      const b = Xo.safeParse(y.currency);
      if (!b.success) {
        l.setFields([{ name: "currency", errors: [b.error.issues[0].message] }]);
        return;
      }
      o({
        ...n,
        itemName: y.itemName,
        from: v.toISOString(),
        to: w ? w.toISOString() : "",
        price: y.price,
        currency: b.data
      }), l.resetFields(), c(null);
    } catch {
    }
  }, A = () => {
    l.resetFields(), c(null), i();
  }, C = () => {
    a && (a(n.id), l.resetFields(), c(null));
  };
  return /* @__PURE__ */ e(
    Ze,
    {
      title: m("en-US", "editPriceScheduleTitle"),
      open: t,
      onOk: p,
      onCancel: A,
      okText: m("en-US", "saveAction"),
      cancelText: m("en-US", "cancelAction"),
      footer: /* @__PURE__ */ d(G, { style: { display: "flex", justifyContent: "space-between", width: "100%" }, children: [
        a ? /* @__PURE__ */ e(
          hr,
          {
            title: m("en-US", "deleteConfirmTitle"),
            description: m("en-US", "deleteScheduleConfirmMessage"),
            onConfirm: C,
            okText: m("en-US", "deleteAction"),
            cancelText: m("en-US", "cancelAction"),
            okButtonProps: { danger: !0 },
            children: /* @__PURE__ */ e(M, { danger: !0, icon: /* @__PURE__ */ e(An, {}), "data-testid": "delete-btn", children: m("en-US", "deleteAction") })
          }
        ) : /* @__PURE__ */ e("div", {}),
        /* @__PURE__ */ d(G, { children: [
          /* @__PURE__ */ e(M, { onClick: A, children: m("en-US", "cancelAction") }),
          /* @__PURE__ */ e(M, { type: "primary", onClick: p, children: m("en-US", "saveAction") })
        ] })
      ] }),
      children: /* @__PURE__ */ d(_, { form: l, layout: "vertical", onFieldsChange: h, children: [
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "itemName",
            label: m("en-US", "itemLabel"),
            rules: [{ required: !0 }],
            children: /* @__PURE__ */ e(W, { "data-testid": "itemName" })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "range",
            label: m("en-US", "dateRangeLabel"),
            rules: [{ required: !0 }],
            validateStatus: s ? "error" : void 0,
            help: s ? m("en-US", s) : void 0,
            children: /* @__PURE__ */ e(En, { "data-testid": "range" })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "price",
            label: m("en-US", "priceLabel"),
            rules: [{ required: !0, type: "number", min: 0 }],
            children: /* @__PURE__ */ e(Tt, { "data-testid": "price", style: { width: "100%" } })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "currency",
            label: m("en-US", "currencyLabel"),
            rules: [{ required: !0 }],
            children: /* @__PURE__ */ e(Xe, { options: Qo, "data-testid": "currency" })
          }
        )
      ] })
    }
  );
}, pt = (t, n = 1) => t.map((r, o, i) => ({
  key: r.id,
  title: r.title,
  children: r.children ? pt(r.children, n + 1) : void 0,
  ariaLevel: n,
  ariaPosinset: o + 1,
  ariaSetsize: i.length
})), Te = (t) => t.map((n) => ({
  id: String(n.key),
  title: typeof n.title == "string" ? n.title : "",
  children: n.children ? Te(n.children) : void 0
})), ot = (t) => t.map((n) => ({
  ...n,
  children: n.children ? ot(n.children) : void 0
})), Rn = (t, n, r) => t.map((o) => {
  if (o.key === n)
    return { ...o, title: r };
  if (o.children) {
    const i = Rn(o.children, n, r);
    if (i !== o.children)
      return { ...o, children: i };
  }
  return o;
}), Bn = (t) => !t.children || t.children.length === 0 ? 1 : 1 + Math.max(...t.children.map(Bn)), rt = (t) => t.length === 0 ? 0 : Math.max(...t.map(Bn)), tl = (t) => {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push({ id: i.id, title: i.title }), i.children && r(i.children);
    });
  };
  return r(t), n;
}, Fn = (t, n) => {
  if (!n) return t;
  const r = n.toLowerCase();
  return t.map((o) => {
    const i = o.children ? Fn(o.children, n) : [];
    return String(o.title).toLowerCase().includes(r) || i.length ? { ...o, children: i } : null;
  }).filter(Boolean);
}, Ae = (t, n, r = null) => {
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    if (i.key === n)
      return { parent: t, index: o, parentNode: r };
    const a = i.children;
    if (a) {
      const l = Ae(a, n, i);
      if (l) return l;
    }
  }
  return null;
}, ft = (t, n, r) => {
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    if (i.key === n)
      return r?.(i, o, t), i;
    if (i.children) {
      const a = ft(i.children, n, r);
      if (a) return a;
    }
  }
  return null;
}, yt = (t, n) => {
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    if (o.key === n)
      return t.splice(r, 1)[0];
    const i = o.children;
    if (i) {
      const a = yt(i, n);
      if (a) return a;
    }
  }
  return null;
}, dn = (t, n) => {
  const r = Ae(t, n);
  if (!r || r.index === 0) return !1;
  const { parent: o, index: i } = r;
  return [o[i - 1], o[i]] = [o[i], o[i - 1]], !0;
}, un = (t, n) => {
  const r = Ae(t, n);
  if (!r || r.index === r.parent.length - 1) return !1;
  const { parent: o, index: i } = r;
  return [o[i], o[i + 1]] = [o[i + 1], o[i]], !0;
}, mn = (t, n) => {
  const r = Ae(t, n);
  if (!r || r.index === 0) return !1;
  const { parent: o, index: i } = r, a = o[i - 1], l = o.splice(i, 1)[0];
  return a.children = a.children || [], a.children.push(l), !0;
}, hn = (t, n) => {
  const r = Ae(t, n);
  if (!r || !r.parentNode) return !1;
  const { parent: o, index: i, parentNode: a } = r, l = Ae(t, a.key);
  if (!l) return !1;
  const s = o.splice(i, 1)[0];
  return l.parent.splice(l.index + 1, 0, s), !0;
}, Zo = () => typeof globalThis.crypto?.randomUUID == "function" ? globalThis.crypto.randomUUID() : Math.random().toString(36).slice(2), Jo = -1e4, ei = -1e4, nl = (t) => {
  const {
    data: n,
    onChange: r,
    className: o,
    maxDepth: i,
    depthErrorMessage: a
  } = t, l = i ?? 4, s = a ?? `Max depth exceeded (limit: ${l})`, { __testOpenMenuForKey: c, __testRenderMenu: u, __testOnFilteredTree: h } = t, [p, A] = I(() => pt(n)), [C, y] = I(""), [v, w] = I(!1), [P, b] = I(null), [O, F] = I(null), [H, k] = I(null), [S, U] = I(""), [f, E] = I(null), { token: L } = Z.useToken(), j = $e(null), B = $e(null), Q = X(() => {
    const N = [], R = (J) => {
      J.forEach((me) => {
        N.push(me.key), me.children && R(me.children);
      });
    };
    return R(p), N;
  }, [p]), Y = X(() => Fn(p, C), [p, C]);
  ie(() => {
    h?.(Y);
  }, [h, Y]), ie(() => (A(pt(n)), () => {
    j.current && clearTimeout(j.current);
  }), [n]), ie(() => {
    if (!(typeof c > "u")) {
      if (c) {
        E({ x: 0, y: 0, key: c });
        return;
      }
      E(null);
    }
  }, [c]);
  const ue = we(() => {
    w(!0), j.current = setTimeout(() => w(!1), 3e3);
  }, []), se = we(
    (N) => {
      if (!O) return;
      const R = ot(p);
      if (N(R, O)) {
        if (rt(Te(R)) > l) {
          ue();
          return;
        }
        A(R), r(Te(R));
      }
    },
    [O, p, l, r, ue]
  ), Le = we(
    (N) => {
      if (!(!N.ctrlKey || !O))
        switch (N.key) {
          case "ArrowUp":
            se(dn);
            break;
          case "ArrowDown":
            se(un);
            break;
          case "ArrowRight":
            se(mn);
            break;
          case "ArrowLeft":
            se(hn);
            break;
        }
    },
    [O, se]
  ), re = we(
    (N, R) => {
      const J = Rn(p, N, R.trim() || "Untitled");
      k(null), A(J), r(Te(J));
    },
    [p, r]
  ), Ie = (N) => {
    const { node: R } = N;
    B.current = R;
  }, Je = () => {
    B.current = null;
  }, dt = (N) => {
    const { node: R } = N, J = B.current ? rt(Te([B.current])) : 1, q = String(R.pos).split("-").length - 1 + J;
    b(q > l ? String(R.key) : null);
  }, V = (N) => {
    const R = N.node.key, J = N.dragNode.key, me = N.node.pos.split("-"), q = N.dropPosition - Number(me.at(-1)), ge = ot(p), ce = yt(ge, J);
    if (!ce) return;
    if (N.dropToGap) {
      const pe = Ae(ge, R);
      if (!pe) return;
      const { parent: ve, index: Ue } = pe;
      ve.splice(q === -1 ? Ue : Ue + 1, 0, ce);
    } else {
      const pe = ft(ge, R);
      if (!pe) return;
      pe.children ??= [], pe.children.unshift(ce);
    }
    const Pe = Te(ge);
    if (rt(Pe) > l) {
      ue(), b(R);
      return;
    }
    b(null), A(ge), r(Pe);
  }, It = (N) => {
    N.event.preventDefault(), E({
      x: N.event.pageX,
      y: N.event.pageY,
      key: String(N.node.key)
    });
  }, De = ({ key: N }) => {
    if (!f) return;
    const R = f.key, J = ot(p);
    if (N === "add") {
      const q = ft(J, R);
      if (!q) return;
      const ge = {
        key: Zo(),
        title: "New node",
        ariaLevel: q.ariaLevel + 1,
        ariaPosinset: (q.children?.length ?? 0) + 1,
        ariaSetsize: (q.children?.length ?? 0) + 1
      };
      q.children = [...q.children ?? [], ge], q.children.forEach((ce, Pe) => {
        ce.ariaPosinset = Pe + 1, ce.ariaSetsize = q.children ? q.children.length : 0;
      });
    } else N === "delete" && yt(J, R);
    const me = Te(J);
    if (rt(me) > l) {
      ue(), b(R), E(null);
      return;
    }
    b(null), A(J), r(me), E(null);
  };
  ie(() => {
    if (!f)
      return;
    const N = () => E(null);
    return document.addEventListener("mousedown", N), () => {
      document.removeEventListener("mousedown", N);
    };
  }, [f]);
  const ut = X(() => {
    const N = (R) => R.map((J) => ({
      ...J,
      className: J.key === P ? "text-red-500" : void 0,
      children: J.children ? N(J.children) : void 0
    }));
    return N(Y);
  }, [Y, P]);
  return /* @__PURE__ */ d(ye, { children: [
    /* @__PURE__ */ e(
      W,
      {
        placeholder: "Filter…",
        allowClear: !0,
        prefix: /* @__PURE__ */ e(_r, {}),
        style: { marginBottom: 8 },
        value: C,
        onChange: (N) => y(N.target.value)
      }
    ),
    v && /* @__PURE__ */ e(
      Ye,
      {
        type: "error",
        message: s,
        closable: !0,
        showIcon: !0,
        style: { marginBottom: 8 }
      }
    ),
    /* @__PURE__ */ e(
      gr,
      {
        className: o,
        blockNode: !0,
        draggable: !0,
        expandedKeys: Q,
        autoExpandParent: !0,
        treeData: ut,
        onClick: (N, R) => {
          F(String(R.key));
        },
        onSelect: (N) => F(String(N[0])),
        onKeyDown: Le,
        onDragStart: Ie,
        onDragEnd: Je,
        onDragOver: dt,
        onDrop: V,
        onRightClick: It,
        titleRender: (N) => H === N.key ? /* @__PURE__ */ e(
          W,
          {
            size: "small",
            autoFocus: !0,
            value: S,
            onChange: (R) => U(R.target.value),
            onBlur: () => re(String(N.key), S),
            onPressEnter: () => re(String(N.key), S),
            onKeyDown: (R) => R.stopPropagation()
          }
        ) : /* @__PURE__ */ e(
          "span",
          {
            onDoubleClick: () => {
              k(String(N.key)), U(String(N.title));
            },
            className: String(N.className || ""),
            children: String(N.title)
          }
        )
      }
    ),
    /* @__PURE__ */ d("div", { style: { marginTop: 8 }, children: [
      /* @__PURE__ */ e(
        M,
        {
          "aria-label": "Move up",
          size: "small",
          disabled: !O,
          onClick: () => se(dn),
          children: "↑"
        }
      ),
      /* @__PURE__ */ e(
        M,
        {
          "aria-label": "Move down",
          size: "small",
          disabled: !O,
          onClick: () => se(un),
          style: { marginLeft: 4 },
          children: "↓"
        }
      ),
      /* @__PURE__ */ e(
        M,
        {
          "aria-label": "Indent",
          size: "small",
          disabled: !O,
          onClick: () => se(mn),
          style: { marginLeft: 4 },
          children: "↪"
        }
      ),
      /* @__PURE__ */ e(
        M,
        {
          "aria-label": "Outdent",
          size: "small",
          disabled: !O,
          onClick: () => se(hn),
          style: { marginLeft: 4 },
          children: "↩"
        }
      )
    ] }),
    f && /* @__PURE__ */ d(
      "div",
      {
        role: "menu",
        "aria-label": "Node actions",
        onMouseDown: (N) => N.stopPropagation(),
        style: {
          position: "absolute",
          left: f.x,
          top: f.y,
          background: L.colorBgElevated,
          border: `1px solid ${L.colorBorder}`,
          borderRadius: L.borderRadiusLG,
          boxShadow: L.boxShadowSecondary,
          display: "flex",
          flexDirection: "column",
          minWidth: 160,
          zIndex: L.zIndexPopupBase
        },
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => De({ key: "add" }),
              style: {
                padding: `${L.paddingXS}px ${L.paddingSM}px`,
                textAlign: "left",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              },
              children: "Add child"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => De({ key: "delete" }),
              style: {
                padding: `${L.paddingXS}px ${L.paddingSM}px`,
                textAlign: "left",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              },
              children: "Delete"
            }
          )
        ]
      }
    ),
    u && f && /* @__PURE__ */ d(
      "div",
      {
        "data-testid": "classification-tree__test-menu",
        style: {
          position: "absolute",
          left: Jo,
          top: ei
        },
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => De({ key: "add" }),
              children: "Add child"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => De({ key: "delete" }),
              children: "Delete"
            }
          )
        ]
      }
    )
  ] });
}, rl = ({
  currency: t = "ZAR",
  style: n,
  onChange: r,
  ...o
}) => /* @__PURE__ */ e(
  Tt,
  {
    step: 0.01,
    style: { width: "100%", ...n },
    formatter: (i) => i == null ? "" : `${Nt(i, t, !1)} ${t}`,
    parser: (i) => Number(String(i).replace(/[A-Za-z\s,]+/g, "")),
    onChange: (i) => r?.(typeof i == "number" ? i : null),
    ...o
  }
), ol = ({
  balance: t = null,
  adjustments: n = []
}) => {
  const [r, o] = I(t), [i, a] = I(n ?? []), l = X(
    () => (i ?? []).filter((c) => c.amount > 0),
    [i]
  ), s = X(
    () => (i ?? []).filter((c) => c.amount < 0),
    [i]
  );
  return ie(() => {
    if (t !== null || n && n.length > 0) {
      o(t), a(n ?? []);
      return;
    }
    (async () => {
      try {
        const u = await fetch("/api/stripe/balance");
        if (!u.ok)
          throw new Error("Failed to fetch balance");
        const h = await u.json();
        o(h.balance), a(Array.isArray(h.adjustments) ? h.adjustments : []);
      } catch (u) {
        console.error(u);
      }
    })();
  }, [t, n]), /* @__PURE__ */ d(ze, { title: "Current Balance", bordered: !1, "data-testid": "balance-card", children: [
    /* @__PURE__ */ e("div", { "data-testid": "current-balance", children: r !== null ? (r / 100).toFixed(2) : "Loading..." }),
    /* @__PURE__ */ d("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e("div", { children: "Credits" }),
      l.length === 0 ? /* @__PURE__ */ e("div", { children: "None" }) : /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 6 }, children: l.map((c) => /* @__PURE__ */ d(
        "div",
        {
          role: "listitem",
          "data-testid": "adjustment-item",
          style: {
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
            borderBottom: "1px solid #f0f0f0"
          },
          children: [
            /* @__PURE__ */ e("div", { children: c.description ?? c.type }),
            /* @__PURE__ */ e("span", { children: (c.amount / 100).toFixed(2) })
          ]
        },
        c.id
      )) })
    ] }),
    /* @__PURE__ */ d("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e("div", { children: "Debits" }),
      s.length === 0 ? /* @__PURE__ */ e("div", { children: "None" }) : /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 6 }, children: s.map((c) => /* @__PURE__ */ d(
        "div",
        {
          role: "listitem",
          "data-testid": "adjustment-item",
          style: {
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
            borderBottom: "1px solid #f0f0f0"
          },
          children: [
            /* @__PURE__ */ e("div", { children: c.description ?? c.type }),
            /* @__PURE__ */ e("span", { children: (c.amount / 100).toFixed(2) })
          ]
        },
        c.id
      )) })
    ] })
  ] });
}, il = ({ invoices: t, groupBySeason: n = !1 }) => {
  const [r, o] = I("ALL"), i = r === "ALL" ? t : t.filter((u) => u.status === r), a = (u) => ({ "data-label": u }), l = X(() => n ? i.reduce(
    (u, h) => {
      const p = h.period.match(/(\d{4})/), A = p ? p[1] : "Unknown";
      return u[A] || (u[A] = []), u[A].push(h), u;
    },
    {}
  ) : { All: i }, [i, n]), s = [
    {
      title: "Invoice #",
      dataIndex: "id",
      sorter: (u, h) => u.id.localeCompare(h.id),
      onCell: () => a("Invoice #")
    },
    {
      title: "Period",
      dataIndex: "period",
      sorter: (u, h) => u.period.localeCompare(h.period),
      onCell: () => a("Period")
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (u, h) => u.amount - h.amount,
      render: (u, h) => /* @__PURE__ */ d(G, { orientation: "vertical", children: [
        /* @__PURE__ */ e(he, { amount: u }),
        h.paidBy && /* @__PURE__ */ e($.Text, { type: "secondary", children: `Paid by ${h.paidBy}` })
      ] }),
      onCell: () => a("Amount")
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (u, h) => u.status.localeCompare(h.status),
      render: (u) => /* @__PURE__ */ e(st, { status: u }),
      onCell: () => a("Status")
    },
    {
      title: "Download PDF",
      dataIndex: "pdfUrl",
      render: (u, h) => /* @__PURE__ */ e("a", { href: u, "aria-label": `Download invoice ${h.id}`, children: "PDF" }),
      onCell: () => a("Download PDF")
    }
  ], c = Array.from(new Set(t.map((u) => u.status)));
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ e(
      Xe,
      {
        placeholder: "Status",
        value: r === "ALL" ? void 0 : r,
        allowClear: !0,
        onChange: (u) => o(u ?? "ALL"),
        style: { width: 160, marginBottom: 16 },
        children: c.map((u) => /* @__PURE__ */ e(Xe.Option, { value: u, children: u }, u))
      }
    ),
    Object.entries(l).map(([u, h]) => /* @__PURE__ */ d(
      "div",
      {
        "data-testid": `season-${u}`,
        style: { marginBottom: n ? 16 : 0 },
        children: [
          n && /* @__PURE__ */ e($.Title, { level: 5, style: { marginTop: 0 }, children: u }),
          /* @__PURE__ */ e(
            ee,
            {
              rowKey: "id",
              columns: s,
              dataSource: h,
              pagination: !1,
              className: "scl-responsive-table"
            }
          )
        ]
      },
      u
    ))
  ] });
}, ti = "_invoiceModal_djzrq_1", ni = "_fullWidth_djzrq_5", ri = "_summaryCell_djzrq_8", oi = "_notesDivider_djzrq_17", ii = "_notesParagraph_djzrq_21", fe = {
  invoiceModal: ti,
  fullWidth: ni,
  summaryCell: ri,
  notesDivider: oi,
  notesParagraph: ii
}, ai = ({ invoice: t }) => /* @__PURE__ */ d(ee.Summary, { children: [
  /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Sub-total" }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: fe.summaryCell, children: /* @__PURE__ */ e(he, { amount: t.subTotal, currency: t.currency }) })
  ] }),
  t.discount !== void 0 && /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Discount" }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: fe.summaryCell, children: /* @__PURE__ */ e(he, { amount: t.discount, currency: t.currency }) })
  ] }),
  t.otherCharges !== void 0 && /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Other Charges" }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: fe.summaryCell, children: /* @__PURE__ */ e(he, { amount: t.otherCharges, currency: t.currency }) })
  ] }),
  /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "VAT" }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: fe.summaryCell, children: /* @__PURE__ */ e(he, { amount: t.vat, currency: t.currency }) })
  ] }),
  /* @__PURE__ */ d(ee.Summary.Row, { children: [
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: /* @__PURE__ */ e($.Text, { strong: !0, children: "Grand Total" }) }),
    /* @__PURE__ */ e(ee.Summary.Cell, { index: 3, align: "right", className: fe.summaryCell, children: /* @__PURE__ */ e(he, { amount: t.grandTotal, currency: t.currency }) })
  ] })
] }), al = ({
  visible: t,
  invoice: n,
  onClose: r,
  onDownloadPdf: o,
  onDelete: i
}) => {
  const [a, l] = z.useState(null), s = [
    { title: "Description", dataIndex: "description", key: "description" },
    { title: "Qty", dataIndex: "qty", key: "qty", align: "right" },
    {
      title: "Unit Price",
      dataIndex: "unitPrice",
      key: "unitPrice",
      render: (u) => /* @__PURE__ */ e(he, { amount: u, currency: n.currency }),
      align: "right"
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (u) => /* @__PURE__ */ e(he, { amount: u, currency: n.currency }),
      align: "right"
    },
    {
      title: "Delete",
      key: "delete",
      align: "center",
      render: (u, h) => /* @__PURE__ */ e(
        M,
        {
          icon: /* @__PURE__ */ e(An, {}),
          "aria-label": "Delete line",
          onClick: () => l(h.id)
        }
      )
    }
  ], c = () => {
    typeof window < "u" && typeof window.print == "function" && window.print();
  };
  return /* @__PURE__ */ d(ye, { children: [
    /* @__PURE__ */ e(
      Ze,
      {
        title: null,
        open: t,
        onCancel: r,
        footer: null,
        width: 720,
        rootClassName: fe.invoiceModal,
        destroyOnClose: !0,
        children: /* @__PURE__ */ d(G, { orientation: "vertical", className: fe.fullWidth, size: "middle", children: [
          /* @__PURE__ */ d(G, { align: "center", wrap: !0, children: [
            /* @__PURE__ */ e(Pn, { size: "small" }),
            /* @__PURE__ */ e($.Text, { strong: !0, children: n.memberName }),
            /* @__PURE__ */ e($.Text, { children: "-" }),
            /* @__PURE__ */ e($.Text, { children: n.invoiceNumber }),
            /* @__PURE__ */ e(st, { status: n.status })
          ] }),
          /* @__PURE__ */ d(de, { column: 1, size: "small", children: [
            /* @__PURE__ */ e(de.Item, { label: "Issuer", children: n.issuerAddress }),
            /* @__PURE__ */ e(de.Item, { label: "Recipient", children: n.recipientAddress }),
            /* @__PURE__ */ e(de.Item, { label: "Issue Date", children: te(n.issueDate).format("YYYY-MM-DD") }),
            /* @__PURE__ */ e(de.Item, { label: "Due Date", children: te(n.dueDate).format("YYYY-MM-DD") })
          ] }),
          /* @__PURE__ */ e(
            ee,
            {
              rowKey: "id",
              dataSource: n.lines,
              columns: s,
              pagination: !1,
              size: "small",
              summary: () => /* @__PURE__ */ e(ai, { invoice: n })
            }
          ),
          n.notes && /* @__PURE__ */ d(ye, { children: [
            /* @__PURE__ */ e(pr, { className: fe.notesDivider }),
            /* @__PURE__ */ e($.Paragraph, { className: fe.notesParagraph, children: n.notes })
          ] }),
          /* @__PURE__ */ d(gt, { justify: "space-between", align: "middle", className: fe.fullWidth, children: [
            /* @__PURE__ */ e(it, { children: o && /* @__PURE__ */ e(
              M,
              {
                icon: /* @__PURE__ */ e(Tr, {}),
                onClick: () => o(n.id),
                "aria-label": "Download PDF",
                children: "Download PDF"
              }
            ) }),
            /* @__PURE__ */ e(it, { children: /* @__PURE__ */ d(G, { children: [
              /* @__PURE__ */ e(M, { icon: /* @__PURE__ */ e(Ar, {}), onClick: c, "aria-label": "Print", children: "Print" }),
              /* @__PURE__ */ e(M, { type: "primary", onClick: r, "aria-label": "Close invoice preview", children: "Close" })
            ] }) })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ e(
      Ze,
      {
        open: a !== null,
        title: "Delete line?",
        onOk: () => {
          a && i?.(a), l(null);
        },
        onCancel: () => l(null),
        okText: "Delete",
        cancelText: "Cancel",
        children: /* @__PURE__ */ e($.Paragraph, { children: "Are you sure you want to remove this line item from the invoice?" })
      }
    )
  ] });
}, sl = ({ data: t = [] }) => {
  const n = Array.isArray(t) ? t : [];
  return /* @__PURE__ */ e(ze, { title: "Feature Usage", bordered: !1, children: /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 8 }, children: (n.length ? n : [{ feature: "N/A", count: 0 }]).map(({ feature: r, count: o }) => /* @__PURE__ */ d(
    "div",
    {
      role: "listitem",
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "6px 0",
        borderBottom: "1px solid #f0f0f0"
      },
      children: [
        /* @__PURE__ */ e("div", { children: r }),
        /* @__PURE__ */ e("div", { children: o })
      ]
    },
    r
  )) }) });
}, ll = ({ data: t = [] }) => /* @__PURE__ */ e(ze, { title: "System Health", bordered: !1, children: t.length ? t.map(({ name: n, value: r }) => /* @__PURE__ */ d("div", { style: { marginBottom: 8 }, children: [
  /* @__PURE__ */ e("div", { children: n }),
  /* @__PURE__ */ e(fr, { percent: r, size: "small" })
] }, n)) : /* @__PURE__ */ e("div", { children: "No data" }) }), si = new Zr(), li = (t) => Kr({
  mutationKey: ["tenantsControllerCreateTenant"],
  mutationFn: (n) => si.tenantsControllerCreateTenant(
    n[0],
    n[1]
  ).then(({ data: r }) => r),
  ...t
}), cl = ({
  open: t,
  onClose: n,
  initialStep: r = 0
}) => {
  const [o, i] = I(r), [a, l] = I({
    name: "",
    email: ""
  }), [s, c] = I(), [u, h] = I([]), p = li(), A = o === 0 && !a.name || o === 1 && !s, C = async () => {
    try {
      const y = { name: a.name };
      await p.mutateAsync([y]), n();
    } catch {
    }
  };
  return /* @__PURE__ */ d(Mn, { open: t, onClose: n, size: 520, children: [
    /* @__PURE__ */ e(
      _t,
      {
        current: o,
        items: [{ title: "Tenant details" }, { title: "Plan selection" }, { title: "Options" }],
        style: { marginBottom: 24 }
      }
    ),
    o === 0 && /* @__PURE__ */ d(_, { layout: "vertical", children: [
      /* @__PURE__ */ e(_.Item, { label: "Name", required: !0, children: /* @__PURE__ */ e(
        W,
        {
          value: a.name,
          onChange: (y) => l({ ...a, name: y.target.value })
        }
      ) }),
      /* @__PURE__ */ e(_.Item, { label: "Email", required: !0, children: /* @__PURE__ */ e(
        W,
        {
          value: a.email,
          onChange: (y) => l({ ...a, email: y.target.value })
        }
      ) })
    ] }),
    o === 1 && /* @__PURE__ */ e(_, { layout: "vertical", children: /* @__PURE__ */ e(_.Item, { label: "Plan", required: !0, children: /* @__PURE__ */ d(Ke.Group, { value: s, onChange: (y) => c(y.target.value), children: [
      /* @__PURE__ */ e(Ke, { value: "basic", children: "Basic" }),
      /* @__PURE__ */ e(Ke, { value: "pro", children: "Pro" })
    ] }) }) }),
    o === 2 && /* @__PURE__ */ e(_, { layout: "vertical", children: /* @__PURE__ */ e(_.Item, { label: "Modules", children: /* @__PURE__ */ d(Oe.Group, { value: u, onChange: (y) => h(y), children: [
      /* @__PURE__ */ e(Oe, { value: "sms", children: "SMS" }),
      /* @__PURE__ */ e(Oe, { value: "reports", children: "Reports" })
    ] }) }) }),
    /* @__PURE__ */ d("div", { style: { marginTop: 24 }, children: [
      o > 0 && /* @__PURE__ */ e(M, { onClick: () => i(o - 1), style: { marginRight: 8 }, children: "Back" }),
      o < 2 && /* @__PURE__ */ e(M, { type: "primary", onClick: () => i(o + 1), disabled: !!A, children: "Next" }),
      o === 2 && /* @__PURE__ */ e(M, { type: "primary", onClick: C, style: { marginRight: 8 }, children: "Finish" }),
      /* @__PURE__ */ e(M, { onClick: n, children: "Cancel" })
    ] })
  ] });
}, $n = sr({
  appName: "MyWebApp"
}), dl = () => lr($n), ul = ({
  children: t,
  appName: n
}) => {
  const [r] = I(() => new Qr());
  return /* @__PURE__ */ e($n.Provider, { value: { appName: n }, children: /* @__PURE__ */ e(Xr, { client: r, children: t }) });
}, ml = ({
  open: t,
  sizes: n,
  onAdd: r,
  onCancel: o
}) => {
  const [i, a] = I();
  return /* @__PURE__ */ e(
    Ze,
    {
      title: "Choose Size",
      open: t,
      onOk: () => {
        i && r(i);
      },
      onCancel: o,
      okButtonProps: { disabled: !i },
      children: /* @__PURE__ */ e(Ke.Group, { onChange: (s) => a(s.target.value), value: i, children: n.map((s) => /* @__PURE__ */ e(Ke, { value: s, "aria-label": `size-${s}`, children: s }, s)) })
    }
  );
}, bt = "id", { Dragger: ci } = yr, di = (t, n) => {
  const r = t.trim().split(/\r?\n/);
  if (!r.length) return [];
  const o = n ?? (r.length > 0 ? r.shift()?.split(",") ?? [] : []);
  return r.map((i, a) => {
    const l = i.split(","), s = o.reduce((c, u, h) => (c[u] = l[h] ?? "", c), {});
    return { [bt]: a, ...s };
  });
}, hl = ({ onUpload: t, headers: n }) => {
  const [r, o] = I([]), i = async (c) => "text" in c && typeof c.text == "function" ? c.text() : new Promise((u, h) => {
    const p = new FileReader();
    p.onload = () => u(p.result), p.onerror = () => h(p.error), p.readAsText(c);
  }), a = async (c) => {
    const u = await i(c), h = di(u, n);
    return o(h), t(h, c), !1;
  }, s = (n ?? (r[0] ? Object.keys(r[0]).filter((c) => c !== bt) : [])).map((c) => ({
    title: c,
    dataIndex: c,
    key: c
  }));
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ d(
      ci,
      {
        beforeUpload: a,
        showUploadList: !1,
        style: { marginBottom: 16 },
        "data-testid": "dropzone",
        children: [
          /* @__PURE__ */ e("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ e(Nr, {}) }),
          /* @__PURE__ */ e("p", { className: "ant-upload-text", children: "Click or drag CSV file to this area to upload" })
        ]
      }
    ),
    r.length > 0 && /* @__PURE__ */ e(ee, { dataSource: r, columns: s, pagination: !1, rowKey: bt })
  ] });
}, ui = ({ onSubmit: t, submitting: n }) => {
  const [r] = _.useForm();
  return /* @__PURE__ */ d(_, { form: r, layout: "vertical", onFinish: t, children: [
    /* @__PURE__ */ e(_.Item, { label: "First name", name: "firstName", rules: [{ required: !0 }], children: /* @__PURE__ */ e(W, {}) }),
    /* @__PURE__ */ e(_.Item, { label: "Last name", name: "lastName", rules: [{ required: !0 }], children: /* @__PURE__ */ e(W, {}) }),
    /* @__PURE__ */ e(_.Item, { label: "Email", name: "email", rules: [{ required: !0, type: "email" }], children: /* @__PURE__ */ e(W, { type: "email" }) }),
    /* @__PURE__ */ e(_.Item, { label: "Phone", name: "phone", children: /* @__PURE__ */ e(W, {}) }),
    /* @__PURE__ */ e(_.Item, { label: "Date of birth", name: "dateOfBirth", children: /* @__PURE__ */ e(Tn, { style: { width: "100%" } }) }),
    /* @__PURE__ */ e(_.Item, { label: "Club ID", name: "clubId", rules: [{ required: !0 }], children: /* @__PURE__ */ e(W, { type: "number" }) }),
    /* @__PURE__ */ e(_.Item, { children: /* @__PURE__ */ e(M, { type: "primary", htmlType: "submit", loading: n, children: "Submit" }) })
  ] });
}, gl = () => {
  const { message: t } = xe.useApp(), [n, r] = I(!1);
  return /* @__PURE__ */ e(ui, { onSubmit: async (i) => {
    r(!0);
    try {
      const a = await globalThis.fetch("/api/members/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...i, clubId: Number(i.clubId) })
      });
      if (!a.ok)
        throw new Error(a.statusText || "Signup failed");
      t.success("Signup successful");
    } catch (a) {
      const l = a;
      t.error(l.message || "Signup failed");
    } finally {
      r(!1);
    }
  }, submitting: n });
}, pl = ({
  label: t,
  error: n,
  id: r,
  className: o = "",
  ...i
}) => {
  const a = r ?? i.name ?? t;
  return /* @__PURE__ */ d("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ e("label", { htmlFor: a, className: "mb-1 text-sm font-medium", children: t }),
    /* @__PURE__ */ e(
      "input",
      {
        id: a,
        className: `border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent ${n ? "border-red-500" : "border-gray-300"} ${o}`,
        ...i
      }
    ),
    n && /* @__PURE__ */ e("p", { className: "mt-1 text-xs text-red-500", children: n })
  ] });
}, fl = ({
  children: t,
  loading: n,
  block: r,
  className: o = "",
  disabled: i,
  ...a
}) => /* @__PURE__ */ e(
  "button",
  {
    className: `bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50 ${r ? "w-full" : ""} ${o}`,
    disabled: i || n,
    ...a,
    children: n ? "Loading..." : t
  }
);
function yl({
  size: t = "middle",
  showTooltip: n = !0,
  className: r
}) {
  const { mode: o, toggleTheme: i } = At(), a = o === "dark", l = /* @__PURE__ */ e(
    M,
    {
      type: "text",
      size: t,
      icon: a ? /* @__PURE__ */ e(Lr, {}) : /* @__PURE__ */ e(Ir, {}),
      onClick: i,
      className: r,
      "aria-label": a ? "Switch to light mode" : "Switch to dark mode",
      style: {
        color: "inherit"
      }
    }
  );
  return n ? /* @__PURE__ */ e(Cn, { title: a ? "Light mode" : "Dark mode", children: l }) : l;
}
function ht(t) {
  window.location.assign(t);
}
const On = {
  google: "/api/auth/google",
  facebook: "/api/auth/facebook"
}, mi = "_loginContainer_19gq9_4", hi = "_embeddedContainer_19gq9_31", gi = "_loginCard_19gq9_36", pi = "_subtitle_19gq9_42", fi = "_formLabel_19gq9_43", yi = "_rememberMe_19gq9_44", bi = "_signupText_19gq9_45", Si = "_dividerWrapper_19gq9_46", wi = "_formInput_19gq9_50", vi = "_dividerLine_19gq9_60", ki = "_ssoButton_19gq9_64", Ci = "_ssoButtonFacebook_19gq9_75 _ssoButton_19gq9_64", xi = "_darkModal_19gq9_87", _i = "_title_19gq9_107", Ti = "_ssoButtonGoogle_19gq9_136 _ssoButton_19gq9_64", Ai = "_signupLink_19gq9_151", Ni = "_forgotLink_19gq9_152", Li = "_mfaCard_19gq9_156", Ii = "_heroSection_19gq9_161", Di = "_heroContent_19gq9_180", Pi = "_heroTitle_19gq9_188", Ui = "_heroSubtitle_19gq9_197", Ei = "_heroFeatures_19gq9_204", Mi = "_heroFeature_19gq9_204", Ri = "_heroFeatureIcon_19gq9_218", Bi = "_floatingShapes_19gq9_230", Fi = "_shape_19gq9_238", $i = "_float_19gq9_230", Oi = "_shape1_19gq9_249", qi = "_shape2_19gq9_257", zi = "_shape3_19gq9_265", Hi = "_loginContent_19gq9_290", Wi = "_embeddedContent_19gq9_301", Vi = "_background_19gq9_315", ji = "_gradientOverlay_19gq9_321", Gi = "_slideUp_19gq9_1", Yi = "_logoContainer_19gq9_374", Ki = "_errorAlert_19gq9_397", Qi = "_ssoButtonsContainer_19gq9_403", Xi = "_passkeyContainer_19gq9_450", Zi = "_passkeyButton_19gq9_457", Ji = "_passkeyHelper_19gq9_462", ea = "_formGroup_19gq9_484", ta = "_optionsRow_19gq9_509", na = "_rememberDevice_19gq9_521", ra = "_submitButton_19gq9_539", oa = "_forgotPasswordLink_19gq9_592", ia = "_mfaToggle_19gq9_597", aa = "_mfaInputsRow_19gq9_608", sa = "_fullWidth_19gq9_632", la = "_patternDots_19gq9_637", ca = "_patternGrid_19gq9_638", da = "_patternStripes_19gq9_639", ua = "_patternConfetti_19gq9_640", T = {
  loginContainer: mi,
  embeddedContainer: hi,
  loginCard: gi,
  subtitle: pi,
  formLabel: fi,
  rememberMe: yi,
  signupText: bi,
  dividerWrapper: Si,
  formInput: wi,
  dividerLine: vi,
  ssoButton: ki,
  ssoButtonFacebook: Ci,
  darkModal: xi,
  title: _i,
  ssoButtonGoogle: Ti,
  signupLink: Ai,
  forgotLink: Ni,
  mfaCard: Li,
  heroSection: Ii,
  heroContent: Di,
  heroTitle: Pi,
  heroSubtitle: Ui,
  heroFeatures: Ei,
  heroFeature: Mi,
  heroFeatureIcon: Ri,
  floatingShapes: Bi,
  shape: Fi,
  float: $i,
  shape1: Oi,
  shape2: qi,
  shape3: zi,
  loginContent: Hi,
  embeddedContent: Wi,
  background: Vi,
  gradientOverlay: ji,
  slideUp: Gi,
  logoContainer: Yi,
  errorAlert: Ki,
  ssoButtonsContainer: Qi,
  passkeyContainer: Xi,
  passkeyButton: Zi,
  passkeyHelper: Ji,
  formGroup: ea,
  optionsRow: ta,
  rememberDevice: na,
  submitButton: ra,
  forgotPasswordLink: oa,
  mfaToggle: ia,
  mfaInputsRow: aa,
  fullWidth: sa,
  patternDots: la,
  patternGrid: ca,
  patternStripes: da,
  patternConfetti: ua
}, { Content: ma } = le, { Title: ha, Text: _e } = $, Lt = "dwAuthSync", ga = "__sclExternalAuthSyncPending", lt = "__DW_SOCIAL_AUTH_REMEMBER__", St = "__DW_SOCIAL_AUTH_CALLBACK__", wt = "dwAuthCb", gn = 22, pa = 9e4, qn = 8, fa = /* @__PURE__ */ new Set([
  "facilities-admin",
  "messaging-admin",
  "teetime-admin",
  "voicepro-web"
]), ya = (t) => t.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, qn), pn = (t) => {
  const n = t, r = typeof n?.userId == "string" ? n.userId : typeof n?.user?.userId == "string" ? n.user.userId : typeof n?.user?.id == "string" ? n.user.id : "", o = typeof n?.challengeId == "string" ? n.challengeId : "";
  return !r || !o ? null : { userId: r, challengeId: o };
}, ba = () => {
  if (typeof navigator > "u")
    return "unknown browser";
  const t = navigator.platform || "unknown platform", n = navigator.userAgent || "unknown browser";
  return `${t} - ${n}`.slice(0, 240);
};
function qe(t, n, r, o = !1, i = []) {
  try {
    const a = n.trim();
    if (!a || a.startsWith("//"))
      return r;
    const l = new URL(a, t);
    if (!(l.protocol === "http:" || l.protocol === "https:"))
      return r;
    const c = i.map((h) => {
      try {
        return new URL(h).origin;
      } catch {
        return null;
      }
    }).filter((h) => h !== null), u = o && c.includes(l.origin);
    return l.origin !== t && !u ? r : l.toString();
  } catch {
    return r;
  }
}
function Qe(t) {
  return !t || t === "/" ? "/" : t.endsWith("/") ? t.slice(0, -1) : t;
}
function vt(t, n = []) {
  const r = Qe(t), o = n.map(Qe);
  return r === "/login" || r === "/register" || r === "/signup" || r === "/forgot-password" || r === "/reset-password" || r.startsWith("/reset-password/") || o.includes(r);
}
function kt(t, n, r, o, i = !1, a = [], l = [], s = 0) {
  if (s > 3)
    return qe(
      t,
      o,
      `${t}/`,
      i,
      a
    );
  const c = qe(
    t,
    o,
    `${t}/`,
    i,
    a
  ), u = qe(
    t,
    r,
    c,
    i,
    a
  );
  try {
    const h = new URL(u, t);
    if (h.origin !== t) {
      const C = Qe(h.pathname);
      if (vt(C, l)) {
        const y = h.searchParams.get("returnTo");
        return y ? kt(
          t,
          n,
          new URL(y, h.origin).toString(),
          c,
          i,
          a,
          l,
          s + 1
        ) : c;
      }
      return u;
    }
    const p = Qe(h.pathname), A = Qe(n);
    if (p === A || vt(p, l)) {
      const C = h.searchParams.get("returnTo");
      return C ? kt(
        t,
        n,
        C,
        c,
        i,
        a,
        l,
        s + 1
      ) : c;
    }
    return u;
  } catch {
    return c;
  }
}
function Sa(t, n, r, o = !1, i = []) {
  try {
    const a = qe(
      t,
      r,
      `${t}/`,
      o,
      i
    ), s = new URLSearchParams(n).get("returnTo");
    return s ? qe(
      t,
      s,
      a,
      o,
      i
    ) : a;
  } catch {
    return `${t}/`;
  }
}
function wa() {
  try {
    const t = new Uint8Array(gn);
    window.crypto.getRandomValues(t);
    const n = t.slice(0, 6).reduce((o, i) => `${o}${i.toString(16).padStart(2, "0")}`, ""), r = t.slice(6).reduce((o, i) => `${o}${i.toString(16).padStart(2, "0")}`, "").slice(0, gn);
    return `cb-${Date.now().toString(36)}-${n}-${r}`;
  } catch {
    return `cb-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  }
}
function va(t) {
  try {
    if (typeof window > "u") return;
    window.sessionStorage.setItem(St, t);
  } catch {
  }
}
function ka() {
  try {
    if (typeof window > "u") return null;
    const t = window.sessionStorage.getItem(St);
    return window.sessionStorage.removeItem(St), t;
  } catch {
    return null;
  }
}
function Ca(t, n) {
  try {
    const r = new URL(t, window.location.origin);
    return r.searchParams.set(wt, n), r.toString();
  } catch {
    return t;
  }
}
function xa(t) {
  try {
    const n = new URLSearchParams(t), r = n.get(wt);
    if (r) return r;
    const o = n.get("returnTo");
    return o ? new URL(o, window.location.origin).searchParams.get(wt) : null;
  } catch {
    return null;
  }
}
function Ct(t) {
  try {
    const n = typeof window < "u" ? window.location.origin : "http://localhost", r = new URL(t, n);
    return r.searchParams.set(Lt, "1"), r.toString();
  } catch {
    return t;
  }
}
function fn(t) {
  try {
    return new URLSearchParams(t).get(Lt) === "1" ? !0 : typeof window < "u" && typeof window.history.state == "object" && window.history.state !== null && window.history.state[ga] === !0;
  } catch {
    return !1;
  }
}
function _a(t, n, r, o, i = !1, a = [], l = []) {
  const s = Sa(
    t,
    r,
    o,
    i,
    a
  ), c = vt(n, l) ? n : "/login", u = new URL(c, t);
  return u.searchParams.set("returnTo", s), u.searchParams.set(Lt, "1"), u.toString();
}
function Ta(t, n = "") {
  const r = typeof process < "u" ? process.env?.[t] : void 0, o = globalThis.importMetaEnv?.[t];
  return r ?? o ?? n;
}
function Aa(t, n, r) {
  if (!r) return t;
  try {
    const o = new URL(t, n);
    return o.origin !== n ? Ct(o.toString()) : o.toString();
  } catch {
    return t;
  }
}
function Na(t, n) {
  try {
    const r = new URLSearchParams(n);
    r.delete("provider"), r.delete("error"), r.delete("error_description");
    const o = r.toString();
    return o ? `${t}?${o}` : t;
  } catch {
    return t;
  }
}
function yn(t) {
  if (typeof window > "u") return;
  const n = window.history.state ?? null;
  window.history.replaceState(n, document.title, t);
}
function La(t) {
  try {
    if (typeof window > "u") return;
    window.sessionStorage.setItem(lt, t ? "1" : "0");
  } catch {
  }
}
function Ia() {
  try {
    if (typeof window > "u") return null;
    const t = window.sessionStorage.getItem(lt);
    return t !== "0" && t !== "1" ? null : (window.sessionStorage.removeItem(lt), t === "1");
  } catch {
    return null;
  }
}
function Da(t) {
  const n = t.get("remember");
  return n === "1" ? !0 : n === "0" ? !1 : Ia() ?? !1;
}
function bn() {
  try {
    if (typeof window > "u") return;
    window.sessionStorage.removeItem(lt);
  } catch {
  }
}
const Pa = ({ style: t }) => /* @__PURE__ */ d(
  "svg",
  {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    focusable: "false",
    "aria-hidden": "true",
    style: { display: "inline-block", verticalAlign: "middle", ...t },
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#4285F4",
          d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#34A853",
          d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#FBBC05",
          d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#EA4335",
          d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        }
      )
    ]
  }
), Ua = {
  google: "ssoButtonGoogle",
  facebook: "ssoButtonFacebook"
}, zn = {
  kind: "oauth",
  id: "google",
  label: "Continue with Google",
  icon: /* @__PURE__ */ e(Pa, {})
}, Hn = {
  kind: "oauth",
  id: "facebook",
  label: "Continue with Facebook",
  icon: /* @__PURE__ */ e(Pr, { style: { fontSize: 20 } })
}, Ea = [
  zn,
  Hn
], Ma = {
  google: zn,
  facebook: Hn
};
function Ra(t) {
  return typeof t == "string" && Object.prototype.hasOwnProperty.call(On, t);
}
function Ba(t) {
  const n = /* @__PURE__ */ new Set(), r = [];
  for (const o of t) {
    if (!Ra(o.id) || n.has(o.id)) continue;
    const i = Ma[o.id], a = o.label.trim() || i.label;
    r.push({
      ...i,
      ...o,
      id: o.id,
      label: a,
      icon: o.icon === void 0 ? i.icon : o.icon
    }), n.add(o.id);
  }
  return r;
}
const bl = ({
  appName: t,
  layoutVariant: n = "full",
  themeMode: r,
  asModal: o = !1,
  backgroundClassName: i,
  backgroundImageUrl: a,
  overlay: l,
  onCloseModal: s,
  defaultEmail: c,
  defaultRemember: u,
  placeholderEmail: h,
  placeholderPassword: p,
  logoLightSrc: A,
  logoDarkSrc: C,
  signupPath: y,
  forgotPasswordPath: v,
  idpBaseUrl: w,
  socialAuthBaseUrl: P,
  heroTitle: b,
  heroSubtitle: O,
  heroFeatures: F,
  redirectTo: H = "/",
  allowExternalReturnTo: k = !1,
  allowedExternalReturnToOrigins: S = [],
  publicAuthRoutePaths: U = [],
  authenticatedState: f,
  passkeyAuth: E,
  providers: L = Ea
}) => {
  const j = ct(), B = wr(), Q = mt((g) => g.isAuthenticated), Y = mt((g) => g.token), ue = mt((g) => g.login), se = f?.isAuthenticated ?? Q, Le = f?.accessToken ?? Y, re = X(() => se ? en() === "cookie" ? !0 : Le ? Jr(Le) > Date.now() + pa : !1 : !1, [Le, se]), Ie = X(() => {
    const g = typeof t == "string" ? t.trim() : "";
    if (g && g.toLowerCase() !== "undefined" && g.toLowerCase() !== "null")
      return g;
    const x = typeof document < "u" ? document.title : "", D = typeof x == "string" ? x.trim() : "";
    return D && D.toLowerCase() !== "undefined" && D.toLowerCase() !== "null" ? D : "DigiWedge";
  }, [t]), Je = X(
    () => fa.has(eo()),
    []
  ), { mode: dt } = At(), { token: V } = Z.useToken(), De = (r ?? (dt === "dark" ? "dark" : "light")) === "dark", { login: ut, loading: N, error: R } = Nn(), { verifyLoginMfa: J, loading: me } = to(), [q, ge] = I(() => ({
    email: c ?? "",
    password: "",
    remember: !!u
  })), [ce, Pe] = I({}), [pe, ve] = I(!1), [Ue, Ee] = I(""), [Dt, ke] = I(""), [Me, Ce] = I(""), [Wn, Pt] = I(!1), [Ut, ae] = I(null), [Et, et] = I(!1), [Mt, Rt] = I(!1), [Bt, Ft] = I(null), { message: $t } = xe.useApp(), Ot = X(
    () => ({
      "--login-primary": V.colorPrimary,
      "--login-primary-strong": V.colorPrimaryActive || V.colorPrimary,
      "--login-primary-muted": V.colorPrimaryBg || V.colorPrimary,
      "--login-bg": V.colorBgLayout,
      "--login-surface": V.colorBgContainer,
      "--login-surface-elevated": V.colorBgElevated,
      "--login-text": V.colorText,
      "--login-text-muted": V.colorTextSecondary,
      "--login-border": V.colorBorder,
      "--login-border-strong": V.colorBorderSecondary || V.colorBorder,
      "--login-shadow": V.boxShadowSecondary,
      "--login-shadow-soft": V.boxShadowTertiary || V.boxShadowSecondary,
      "--login-radius-lg": `${V.borderRadiusLG}px`,
      "--login-radius-md": `${V.borderRadius}px`,
      "--login-radius-sm": `${V.borderRadiusSM}px`,
      "--login-hero-text": V.colorTextLightSolid || V.colorText,
      "--login-hero-subtext": V.colorTextLightSolid || V.colorTextSecondary,
      "--login-hero-accent": V.colorPrimary
    }),
    [V]
  ), qt = (g) => (x) => ge((D) => ({
    ...D,
    [g]: x.target.value
  })), Vn = (g) => ge((x) => ({
    ...x,
    remember: g.target.checked
  })), ne = z.useCallback(
    (g, x, D) => {
      Promise.resolve().then(() => {
        const K = D ? /* @__PURE__ */ d("span", { children: [
          /* @__PURE__ */ e("span", { children: x }),
          /* @__PURE__ */ e("div", { style: { fontSize: 12, opacity: 0.85 }, children: D })
        ] }) : x;
        $t.open({ type: g, content: K });
      });
    },
    [$t]
  ), jn = (g) => !!g && typeof g == "object" && "accessToken" in g && typeof g.accessToken == "string" && g.accessToken.length > 0, zt = z.useCallback(
    (g, x) => {
      const D = no(), K = en(), Se = x?.sharedSession ?? (K === "cookie" || q.remember || !jn(g));
      return { type: "login", at: Date.now(), sourceId: D, sharedSession: Se };
    },
    [q.remember]
  ), He = z.useCallback(
    (g, x) => {
      ro(zt(g, x));
    },
    [zt]
  ), Gn = async (g) => {
    g.preventDefault();
    const x = {};
    if (q.email ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(q.email) || (x.email = m("en-US", "loginInvalidEmail")) : x.email = m("en-US", "loginEmailRequired"), q.password || (x.password = m("en-US", "loginPasswordRequired")), Pe(x), !Object.keys(x).length)
      try {
        const D = await ut(q), K = pn(D);
        if (K) {
          ke(K.userId), Ce(K.challengeId), Ee(""), et(!1), ae(null), ne("info", "Verification code sent. Check your phone."), ve(!0);
          return;
        }
        if (D?.mfaRequired) {
          ke(""), Ce(""), Ee(""), ae("Verification could not start. Please sign in again to request a new code."), ve(!0);
          return;
        }
        ke(""), Ce(""), ne("success", m("en-US", "loginSuccess")), He(D), We(D);
      } catch (D) {
        const K = D?.message || "";
        /401|invalid/i.test(K) ? ne("error", "Email or password is incorrect.") : /423|lock/i.test(K) ? ne(
          "error",
          "Your account is temporarily locked. Try again later or reset your password."
        ) : /429|rate|too many/i.test(K) ? ne("error", "Too many attempts. Please wait a moment and try again.") : ne("error", m("en-US", "loginError"));
      }
  }, Yn = X(
    () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(q.email),
    [q.email]
  ), Kn = X(() => q.password.length > 0, [q.password]), Qn = Yn && Kn, Ht = w === null ? "" : w ?? Ta("VITE_IDP_BASE_URL", ""), Wt = Ht.replace(/\/$/, ""), Xn = (P ?? Ht).replace(/\/$/, ""), Vt = X(() => {
    try {
      const x = new URLSearchParams(B.search).get("returnTo");
      if (x) {
        const D = qe(
          window.location.origin,
          x,
          "",
          k,
          S
        );
        if (D) return D;
      }
    } catch {
    }
    return null;
  }, [k, S, B.search]) ?? H, Re = X(
    () => kt(
      window.location.origin,
      B.pathname,
      Vt,
      H,
      k,
      S,
      U
    ),
    [
      k,
      S,
      Vt,
      B.pathname,
      U,
      H
    ]
  ), Zn = X(() => _a(
    window.location.origin,
    B.pathname,
    B.search,
    H,
    k,
    S,
    U
  ), [
    k,
    S,
    B.pathname,
    B.search,
    U,
    H
  ]), Jn = y ?? "/signup", jt = v || w === null ? null : Wt ? `${Wt}/forgot-password` : "/forgot-password", er = E?.label ?? "Sign in with Passkey", Gt = E?.helperText, tr = E?.isAvailable ?? !0, Yt = X(
    () => Ba(L),
    [L]
  ), Kt = Yt.length > 0, We = z.useCallback(
    (g) => {
      const x = k && fn(B.search);
      try {
        const D = new URL(Re, window.location.origin), K = x && D.origin !== window.location.origin ? Ct(D.toString()) : D.toString();
        D.origin === window.location.origin ? j(D.pathname + D.search + D.hash, { replace: !0 }) : ht(K);
      } catch {
        const D = x ? Ct(Re) : Re;
        j(D, { replace: !0 });
      }
    },
    [k, Re, B.search, j]
  );
  ie(() => {
    try {
      const g = typeof window < "u" ? window.location.hash : "";
      if (!g || !g.includes("accessToken=")) return;
      const x = ka(), D = xa(window.location.search);
      if (!x || D !== x) {
        bn();
        return;
      }
      const K = new URLSearchParams(g.replace(/^#/, "")), Se = K.get("accessToken");
      if (!Se) return;
      const nt = K.get("refreshToken") ?? void 0, Be = K.get("jti") ?? void 0, Ve = Da(K), je = { accessToken: Se, refreshToken: nt, jti: Be };
      oo(), ue(Se, nt, Be, Ve), He(je, { sharedSession: Ve }), yn(window.location.pathname + window.location.search), We(je);
    } catch {
    }
  }, [He, We, ue]), ie(() => {
    if (!re) return;
    const g = Aa(
      Re,
      window.location.origin,
      k && fn(B.search)
    );
    try {
      const x = new URL(g, window.location.origin);
      if (x.origin === window.location.origin) {
        j(x.pathname + x.search + x.hash, { replace: !0 });
        return;
      }
      ht(x.toString());
    } catch {
      j(g, { replace: !0 });
    }
  }, [
    k,
    Re,
    B.search,
    j,
    re
  ]);
  const nr = async () => {
    if (E) {
      Ft(null);
      try {
        Rt(!0);
        const g = await E.onAuthenticate({
          email: q.email.trim() || void 0,
          remember: q.remember
        }), x = pn(g);
        if (x) {
          ke(x.userId), Ce(x.challengeId), Ee(""), et(!1), ae(null), ne("info", "Verification code sent. Check your phone."), ve(!0);
          return;
        }
        if (g?.mfaRequired) {
          ke(""), Ce(""), Ee(""), ae("Verification could not start. Please sign in again to request a new code."), ve(!0);
          return;
        }
        ke(""), Ce(""), ne("success", m("en-US", "loginSuccess")), He(g), We(g);
      } catch (g) {
        if (tn(g)) {
          const { message: x } = Jt(
            g,
            "Passkey sign-in failed"
          );
          Ft(x), ne("error", x);
        } else g instanceof Error ? g.name === "NotAllowedError" ? ne("info", "Passkey request was cancelled.") : g.name === "NotSupportedError" ? ne("error", "Passkeys are not supported on this device.") : ne("error", g.message || "Passkey sign-in failed") : ne("error", "Passkey sign-in failed");
      } finally {
        Rt(!1);
      }
    }
  }, rr = (g) => {
    const x = On[g];
    if (!x)
      return;
    La(q.remember);
    const D = wa();
    va(D);
    const K = Ca(Zn, D), Se = q.remember ? "1" : "0";
    ht(
      `${Xn}${x}?returnTo=${encodeURIComponent(K)}&remember=${Se}`
    );
  }, Qt = async () => {
    if (ae(null), !Ue) {
      ae("Enter the verification or backup code.");
      return;
    }
    if (!Me) {
      ae("Sign in first to request a verification code.");
      return;
    }
    if (!Dt) {
      ae("We could not identify your account. Please sign in again.");
      return;
    }
    try {
      Pt(!0);
      const g = await J({
        userId: Dt,
        challengeId: Me,
        code: Ue,
        remember: q.remember,
        ...Je && Et ? { rememberDevice: !0, deviceInfo: ba() } : {}
      });
      ne("success", m("en-US", "loginSuccess")), ve(!1), ke(""), Ce(""), He(g), We(g);
    } catch (g) {
      if (tn(g)) {
        const { code: x, message: D } = Jt(
          g,
          "Verification failed"
        );
        ae(x === "otp-invalid" ? "Invalid code. Please try again." : x === "otp-expired" ? "Code expired. Request a new code." : x === "otp-rate-limited" ? "Too many attempts. Please wait and try again." : x === "server-error" || x === "network-error" ? `${D}. You can try again.` : D);
      } else
        ae("Verification failed");
    } finally {
      Pt(!1);
    }
  };
  ie(() => {
    pe || (ke(""), Ce(""), Ee(""), et(!1), ae(null));
  }, [pe]), ie(() => {
    const { pathname: g, search: x } = window.location, D = lo(window.location);
    if (!D) return;
    const { code: K, provider: Se = "", description: nt } = D, Be = Se.toLowerCase(), Ve = (nt || "").trim(), je = Be ? Be.charAt(0).toUpperCase() + Be.slice(1) : "Social account";
    K === "not-linked" ? ne(
      "error",
      `${je} is not linked to your account yet. Sign in with your email to finish linking.`
    ) : K === "oauth-failed" ? ne("error", `${je} authentication failed.`, Ve || void 0) : ne("error", "Authentication failed.", Ve || void 0), bn(), yn(Na(g, x));
  }, [ne]);
  const or = F?.length ? F : ["Secure single sign-on", "Multi-factor authentication", "Enterprise-grade security"], tt = n === "embedded", Xt = /* @__PURE__ */ d(ze, { className: T.loginCard, variant: "borderless", children: [
    /* @__PURE__ */ e(ha, { level: 3, className: T.title, children: "Welcome back" }),
    /* @__PURE__ */ d(_e, { className: T.subtitle, children: [
      "Sign in to continue to ",
      Ie
    ] }),
    R && /* @__PURE__ */ e(
      Ye,
      {
        title: m("en-US", "loginFailedTitle"),
        description: /401|invalid/i.test(R.message) ? "Email or password incorrect." : /423|lock/i.test(R.message) ? "Your account is locked due to multiple failed attempts." : R?.message,
        type: "error",
        showIcon: !0,
        className: T.errorAlert
      }
    ),
    Kt && /* @__PURE__ */ e("div", { style: { marginTop: "16px" }, className: T.ssoButtonsContainer, children: Yt.map((g) => /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: T[Ua[g.id]],
        onClick: () => rr(g.id),
        children: [
          g.icon,
          /* @__PURE__ */ e("span", { children: g.label })
        ]
      },
      g.id
    )) }),
    E && /* @__PURE__ */ d("div", { className: T.passkeyContainer, children: [
      /* @__PURE__ */ e(
        M,
        {
          type: "default",
          size: "large",
          block: !0,
          onClick: nr,
          loading: Mt,
          disabled: !tr || Mt,
          className: T.passkeyButton,
          children: er
        }
      ),
      Gt && /* @__PURE__ */ e(_e, { type: "secondary", className: T.passkeyHelper, children: Gt }),
      Bt && /* @__PURE__ */ e(Ye, { type: "error", title: Bt, showIcon: !0 })
    ] }),
    Kt && /* @__PURE__ */ d("div", { className: T.dividerWrapper, children: [
      /* @__PURE__ */ e("div", { className: T.dividerLine }),
      /* @__PURE__ */ e("span", { children: "or continue with email" }),
      /* @__PURE__ */ e("div", { className: T.dividerLine })
    ] }),
    /* @__PURE__ */ d("form", { onSubmit: Gn, children: [
      /* @__PURE__ */ d("div", { className: T.formGroup, children: [
        /* @__PURE__ */ e("label", { className: T.formLabel, htmlFor: "email", children: "Email address" }),
        /* @__PURE__ */ e(
          W,
          {
            type: "email",
            size: "large",
            id: "email",
            className: T.formInput,
            value: q.email,
            onChange: qt("email"),
            autoComplete: "username",
            status: ce.email ? "error" : "",
            placeholder: h || "you@example.com"
          }
        ),
        ce.email && /* @__PURE__ */ e(_e, { type: "danger", style: { fontSize: 12, marginTop: 4 }, children: ce.email })
      ] }),
      /* @__PURE__ */ d("div", { className: T.formGroup, children: [
        /* @__PURE__ */ e("label", { className: T.formLabel, htmlFor: "password", children: "Password" }),
        /* @__PURE__ */ e(
          W.Password,
          {
            size: "large",
            id: "password",
            className: T.formInput,
            value: q.password,
            onChange: qt("password"),
            autoComplete: "current-password",
            status: ce.password ? "error" : "",
            placeholder: p || "Enter your password"
          }
        ),
        ce.password && /* @__PURE__ */ e(_e, { type: "danger", style: { fontSize: 12, marginTop: 4 }, children: ce.password })
      ] }),
      /* @__PURE__ */ d("div", { className: T.optionsRow, children: [
        /* @__PURE__ */ e(
          Oe,
          {
            checked: q.remember,
            onChange: Vn,
            className: T.rememberMe,
            children: "Remember me"
          }
        ),
        v ? /* @__PURE__ */ e(at, { to: v, className: T.forgotLink, children: "Forgot password?" }) : jt ? /* @__PURE__ */ e("a", { href: jt, className: T.forgotLink, children: "Forgot password?" }) : null
      ] }),
      /* @__PURE__ */ e(
        M,
        {
          htmlType: "submit",
          type: "primary",
          size: "large",
          disabled: !Qn || N,
          loading: N,
          block: !0,
          className: T.submitButton,
          children: "Sign in"
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: T.mfaToggle, children: /* @__PURE__ */ e(
      br,
      {
        activeKey: pe ? ["mfa"] : [],
        onChange: (g) => {
          const x = Array.isArray(g) ? g.includes("mfa") : !!g;
          ve(x);
        },
        ghost: !0,
        items: [
          {
            key: "mfa",
            label: /* @__PURE__ */ e(_e, { type: "secondary", children: "Have a verification code?" }),
            children: /* @__PURE__ */ e("div", { className: T.mfaCard, children: /* @__PURE__ */ d(G, { orientation: "vertical", className: T.fullWidth, size: "middle", children: [
              /* @__PURE__ */ e(_e, { type: "secondary", children: Me ? "Enter the verification or backup code to finish signing in, then press Enter or Verify." : "Sign in first to request a verification code." }),
              /* @__PURE__ */ e(
                W,
                {
                  placeholder: "Enter code",
                  inputMode: "text",
                  value: Ue,
                  onChange: (g) => Ee(ya(g.target.value)),
                  onPressEnter: Qt,
                  maxLength: qn,
                  size: "large",
                  className: T.formInput,
                  disabled: !Me
                }
              ),
              Je && /* @__PURE__ */ e(
                Oe,
                {
                  checked: Et,
                  disabled: !Me,
                  onChange: (g) => et(g.target.checked),
                  className: T.rememberDevice,
                  children: "Remember this device for 30 days"
                }
              ),
              Ut && /* @__PURE__ */ e(Ye, { type: "error", title: Ut, showIcon: !0 }),
              /* @__PURE__ */ e(
                M,
                {
                  type: "primary",
                  onClick: Qt,
                  loading: Wn || me,
                  disabled: !Me,
                  block: !0,
                  size: "large",
                  className: T.submitButton,
                  children: "Verify"
                }
              )
            ] }) })
          }
        ]
      }
    ) }),
    /* @__PURE__ */ e("div", { className: T.signupText, children: /* @__PURE__ */ d(_e, { children: [
      m("en-US", "dontHaveAccount"),
      /* @__PURE__ */ e(at, { to: Jn, className: T.signupLink, children: m("en-US", "signUpButton") })
    ] }) })
  ] });
  return o ? /* @__PURE__ */ e(
    Ze,
    {
      open: !0,
      centered: !0,
      footer: null,
      onCancel: s,
      width: 480,
      destroyOnHidden: !0,
      closable: !0,
      maskClosable: !0,
      keyboard: !0,
      className: De ? T.darkModal : void 0,
      styles: { body: { padding: 0 }, mask: { borderRadius: 24 } },
      children: /* @__PURE__ */ e("div", { style: Ot, children: Xt })
    }
  ) : /* @__PURE__ */ d(
    le,
    {
      className: `${T.loginContainer}${tt ? ` ${T.embeddedContainer}` : ""}`,
      style: Ot,
      children: [
        !tt && /* @__PURE__ */ d("div", { className: T.heroSection, children: [
          /* @__PURE__ */ d("div", { className: T.floatingShapes, children: [
            /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape1}` }),
            /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape2}` }),
            /* @__PURE__ */ e("div", { className: `${T.shape} ${T.shape3}` })
          ] }),
          /* @__PURE__ */ d("div", { className: T.heroContent, children: [
            /* @__PURE__ */ e("h1", { className: T.heroTitle, children: b || Ie }),
            /* @__PURE__ */ e("p", { className: T.heroSubtitle, children: O || "Your complete business management platform" }),
            /* @__PURE__ */ e("div", { className: T.heroFeatures, children: or.map((g, x) => /* @__PURE__ */ d("div", { className: T.heroFeature, children: [
              /* @__PURE__ */ e("span", { className: T.heroFeatureIcon, children: /* @__PURE__ */ e(Dr, { style: { color: "#fff", fontSize: 14 } }) }),
              /* @__PURE__ */ e("span", { children: g })
            ] }, x)) })
          ] })
        ] }),
        !tt && /* @__PURE__ */ d(ye, { children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: `${T.background} ${i ?? ""}`,
              style: a ? {
                backgroundImage: `url(${a})`,
                backgroundSize: "cover",
                backgroundPosition: "center"
              } : void 0
            }
          ),
          l !== "none" && /* @__PURE__ */ e("div", { className: T.gradientOverlay })
        ] }),
        /* @__PURE__ */ e(
          ma,
          {
            className: `${T.loginContent}${tt ? ` ${T.embeddedContent}` : ""}`,
            children: Xt
          }
        )
      ]
    }
  );
}, Fa = "_page_18e0n_1", $a = "_shell_18e0n_9", Oa = "_brandPanel_18e0n_20", qa = "_brandContent_18e0n_29", za = "_brandBadge_18e0n_34", Ha = "_brandTitle_18e0n_46", Wa = "_brandSubtitle_18e0n_51", Va = "_brandList_18e0n_55", ja = "_brandQuote_18e0n_63", Ga = "_brandQuoteText_18e0n_71", Ya = "_brandQuoteAuthor_18e0n_76", Ka = "_formPanel_18e0n_82", Qa = "_formHeader_18e0n_89", Xa = "_alert_18e0n_94", Za = "_footerRow_18e0n_98", Ja = "_link_18e0n_102", oe = {
  page: Fa,
  shell: $a,
  brandPanel: Oa,
  brandContent: qa,
  brandBadge: za,
  brandTitle: Ha,
  brandSubtitle: Wa,
  brandList: Va,
  brandQuote: ja,
  brandQuoteText: Ga,
  brandQuoteAuthor: Ya,
  formPanel: Ka,
  formHeader: Qa,
  alert: Xa,
  footerRow: Za,
  link: Ja
}, { Title: Sn, Text: Ge } = $, es = [
  "Secure access with role-based permissions.",
  "Unified records across teams and workflows.",
  "Live reporting for confident decisions."
], Sl = ({
  appName: t,
  logoLightSrc: n,
  logoDarkSrc: r,
  highlights: o = es,
  quote: i = '"Onboarding our team took minutes, not days."',
  quoteAuthor: a = "Operations Lead"
}) => {
  const { message: l } = xe.useApp(), { locale: s } = Er(), c = ct(), { register: u, loading: h, error: p } = Ln(), { token: A } = Z.useToken(), C = z.useMemo(() => {
    const w = typeof t == "string" ? t.trim() : "";
    if (w && w.toLowerCase() !== "undefined" && w.toLowerCase() !== "null")
      return w;
    const P = typeof document < "u" ? document.title : "", b = typeof P == "string" ? P.trim() : "";
    return b && b.toLowerCase() !== "undefined" && b.toLowerCase() !== "null" ? b : "DigiWedge";
  }, [t]), y = async (w) => {
    try {
      await u(w), l.success(m(s, "registrationSuccess")), c("/login");
    } catch {
      l.error(m(s, "registrationError"));
    }
  }, v = {
    "--register-bg": A.colorBgLayout || "#f0f2f5",
    "--register-surface": A.colorBgContainer || "#ffffff",
    "--register-border": A.colorBorderSecondary || "#e6e8ec",
    "--register-primary": A.colorPrimary || "#1677ff"
  };
  return /* @__PURE__ */ e("div", { className: oe.page, style: v, children: /* @__PURE__ */ d("div", { className: oe.shell, children: [
    /* @__PURE__ */ d("aside", { className: oe.brandPanel, children: [
      /* @__PURE__ */ e(
        Pn,
        {
          themeMode: "dark",
          size: "medium",
          lightLogoSrc: n,
          darkLogoSrc: r,
          alt: `${C} logo`
        }
      ),
      /* @__PURE__ */ d("div", { className: oe.brandContent, children: [
        /* @__PURE__ */ e("span", { className: oe.brandBadge, children: m(s, "signUpButton") }),
        /* @__PURE__ */ d(Sn, { level: 2, className: oe.brandTitle, children: [
          "Create your ",
          C,
          " account"
        ] }),
        /* @__PURE__ */ e(Ge, { className: oe.brandSubtitle, children: "Bring your team together with secure access and unified workflows." })
      ] }),
      /* @__PURE__ */ e("ul", { className: oe.brandList, children: o.map((w) => /* @__PURE__ */ e("li", { children: w }, w)) }),
      /* @__PURE__ */ d("div", { className: oe.brandQuote, children: [
        /* @__PURE__ */ e(Ge, { className: oe.brandQuoteText, children: i }),
        /* @__PURE__ */ e(Ge, { className: oe.brandQuoteAuthor, children: a })
      ] })
    ] }),
    /* @__PURE__ */ d("section", { className: oe.formPanel, children: [
      /* @__PURE__ */ d("div", { className: oe.formHeader, children: [
        /* @__PURE__ */ e(Sn, { level: 3, children: m(s, "registerHeading").replace("{appName}", C) }),
        /* @__PURE__ */ e(Ge, { type: "secondary", children: "Fill in the details below to get started." })
      ] }),
      p && /* @__PURE__ */ e(
        Ye,
        {
          message: m(s, "registrationFailedTitle"),
          description: p.message,
          type: "error",
          showIcon: !0,
          className: oe.alert
        }
      ),
      /* @__PURE__ */ d(_, { name: "register", layout: "vertical", onFinish: y, children: [
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m(s, "emailLabel"),
            name: "email",
            rules: [
              {
                required: !0,
                message: m(s, "registerAccountEmailRequired")
              },
              {
                type: "email",
                message: m(s, "registerAccountInvalidEmail")
              }
            ],
            children: /* @__PURE__ */ e(W, { placeholder: m(s, "emailPlaceholder"), size: "large" })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m(s, "passwordLabel"),
            name: "password",
            rules: [
              {
                required: !0,
                message: m(s, "registerAccountPasswordRequired")
              },
              {
                min: 8,
                message: m(s, "registerAccountPasswordMin")
              }
            ],
            children: /* @__PURE__ */ e(
              W.Password,
              {
                placeholder: m(s, "passwordPlaceholder"),
                size: "large"
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m(s, "firstNameLabel"),
            name: "givenName",
            rules: [
              {
                required: !0,
                message: m(s, "registerAccountFirstNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(W, { size: "large" })
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m(s, "lastNameLabel"),
            name: "familyName",
            rules: [
              {
                required: !0,
                message: m(s, "registerAccountLastNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(W, { size: "large" })
          }
        ),
        /* @__PURE__ */ e(_.Item, { label: m(s, "preferredNameLabel"), name: "preferredName", children: /* @__PURE__ */ e(W, { size: "large" }) }),
        /* @__PURE__ */ e(
          _.Item,
          {
            name: "termsAccepted",
            valuePropName: "checked",
            rules: [
              {
                validator: (w, P) => P ? Promise.resolve() : Promise.reject(new Error(m(s, "termsRequired")))
              }
            ],
            children: /* @__PURE__ */ e(Oe, { children: m(s, "termsAcceptLabel") })
          }
        ),
        /* @__PURE__ */ e(M, { type: "primary", htmlType: "submit", block: !0, size: "large", loading: h, children: m(s, "signUpButton") })
      ] }),
      /* @__PURE__ */ e("div", { className: oe.footerRow, children: /* @__PURE__ */ d(Ge, { children: [
        m(s, "alreadyHaveAccount"),
        " ",
        /* @__PURE__ */ e(at, { to: "/login", className: oe.link, children: m(s, "loginLinkText") })
      ] }) })
    ] })
  ] }) });
}, wl = () => {
  const t = ct(), { logout: n } = io(), { token: r } = Z.useToken(), { message: o } = xe.useApp(), i = $e(!1);
  return ie(() => {
    if (i.current)
      return;
    i.current = !0, (async () => {
      try {
        await n(), o.success(m("en-US", "logoutSuccess"));
      } catch {
        o.error(m("en-US", "logoutError"));
      } finally {
        t("/login", { replace: !0 });
      }
    })();
  }, [n, t, o]), /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: r.colorBgContainer
      },
      children: /* @__PURE__ */ d("div", { style: { display: "grid", justifyItems: "center", gap: 12 }, children: [
        /* @__PURE__ */ e(vn, { size: "large" }),
        /* @__PURE__ */ e("span", { style: { color: r.colorTextSecondary }, children: m("en-US", "logoutProgress") })
      ] })
    }
  );
}, ts = () => /* @__PURE__ */ d("div", { children: [
  /* @__PURE__ */ e("h2", { children: m("en-US", "registrationComplete") }),
  /* @__PURE__ */ e("p", { children: m("en-US", "registrationCompleteDetail") }),
  /* @__PURE__ */ e("p", { children: /* @__PURE__ */ e("a", { href: "/login", children: m("en-US", "goToLogin") }) })
] }), ns = ({
  onNext: t,
  loading: n,
  serverError: r
}) => {
  const { message: o } = xe.useApp(), [i] = _.useForm();
  return ie(() => {
    if (r?.fieldErrors) {
      const l = Object.entries(r.fieldErrors).map(
        ([s, c]) => ({
          name: [s],
          errors: [c]
        })
      );
      i.setFields(l);
    }
  }, [r, i]), /* @__PURE__ */ e("div", { children: /* @__PURE__ */ d(
    _,
    {
      form: i,
      layout: "vertical",
      onFinish: async (l) => {
        try {
          await t(l);
        } catch {
          o.error(m("en-US", "registrationSubmitError"));
        }
      },
      onFinishFailed: (l) => {
        process.env.NODE_ENV !== "test" && console.warn("Validation Failed:", l);
      },
      children: [
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m("en-US", "emailLabel"),
            name: "email",
            rules: [
              {
                required: !0,
                message: m("en-US", "registerAccountEmailRequired")
              },
              {
                type: "email",
                message: m("en-US", "registerAccountInvalidEmail")
              }
            ],
            children: /* @__PURE__ */ e(W, {})
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m("en-US", "passwordLabel"),
            name: "password",
            rules: [
              {
                required: !0,
                message: m("en-US", "registerAccountPasswordRequired")
              },
              {
                min: 8,
                message: m("en-US", "registerAccountPasswordMin")
              },
              {
                validator: (l, s) => {
                  if (!s) return Promise.resolve();
                  const c = /[A-Z]/.test(s), u = /[a-z]/.test(s), h = /\d/.test(s);
                  return !c || !u || !h ? Promise.reject(m("en-US", "registerAccountPasswordComplex")) : Promise.resolve();
                }
              }
            ],
            children: /* @__PURE__ */ e(W.Password, {})
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m("en-US", "firstNameLabel"),
            name: "givenName",
            rules: [
              {
                required: !0,
                message: m("en-US", "registerAccountFirstNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(W, {})
          }
        ),
        /* @__PURE__ */ e(
          _.Item,
          {
            label: m("en-US", "lastNameLabel"),
            name: "familyName",
            rules: [
              {
                required: !0,
                message: m("en-US", "registerAccountLastNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(W, {})
          }
        ),
        /* @__PURE__ */ e(_.Item, { label: m("en-US", "preferredNameLabel"), name: "preferredName", children: /* @__PURE__ */ e(W, {}) }),
        /* @__PURE__ */ e(M, { type: "primary", htmlType: "submit", block: !0, loading: n, children: m("en-US", "registerButton") })
      ]
    }
  ) });
}, rs = ({ onLogin: t, loading: n }) => {
  const [r] = _.useForm();
  async function o(i) {
    await t(i);
  }
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ e("h2", { children: m("en-US", "loginHeading") }),
    /* @__PURE__ */ d(
      _,
      {
        form: r,
        layout: "vertical",
        onFinish: o,
        initialValues: { email: "", password: "" },
        children: [
          /* @__PURE__ */ e(
            _.Item,
            {
              label: m("en-US", "emailLabel"),
              name: "email",
              rules: [
                {
                  required: !0,
                  message: m("en-US", "loginEmailRequired")
                },
                {
                  type: "email",
                  message: m("en-US", "loginInvalidEmail")
                }
              ],
              children: /* @__PURE__ */ e(W, {})
            }
          ),
          /* @__PURE__ */ e(
            _.Item,
            {
              label: m("en-US", "passwordLabel"),
              name: "password",
              rules: [
                {
                  required: !0,
                  message: m("en-US", "loginPasswordRequired")
                }
              ],
              children: /* @__PURE__ */ e(W.Password, {})
            }
          ),
          /* @__PURE__ */ e(M, { type: "primary", htmlType: "submit", block: !0, loading: n, children: m("en-US", "loginButton") })
        ]
      }
    )
  ] });
}, os = ({ onNext: t, loading: n }) => {
  const [r] = _.useForm(), o = (i) => {
    t(i);
  };
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ e("h2", { children: m("en-US", "mfaPhoneHeading") }),
    /* @__PURE__ */ d(_, { form: r, layout: "vertical", onFinish: o, children: [
      /* @__PURE__ */ e(
        _.Item,
        {
          label: m("en-US", "phoneNumberLabel"),
          name: "phoneNumber",
          rules: [
            {
              required: !0,
              message: m("en-US", "mfaPhoneRequired")
            }
          ],
          children: /* @__PURE__ */ e(W, { placeholder: m("en-US", "phoneNumberPlaceholder") })
        }
      ),
      /* @__PURE__ */ e(_.Item, { label: m("en-US", "mfaSecretLabel"), name: "secret", rules: [], children: /* @__PURE__ */ e(W, { placeholder: m("en-US", "mfaSecretPlaceholder") }) }),
      /* @__PURE__ */ e(M, { type: "primary", htmlType: "submit", block: !0, loading: n, children: m("en-US", "sendCodeButton") })
    ] })
  ] });
}, is = ({ onVerify: t, loading: n }) => {
  const [r] = _.useForm(), o = (i) => {
    t(i.code);
  };
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ e("h2", { children: m("en-US", "mfaCodeHeading") }),
    /* @__PURE__ */ d(_, { form: r, layout: "vertical", onFinish: o, children: [
      /* @__PURE__ */ e(
        _.Item,
        {
          label: m("en-US", "mfaCodeLabel"),
          name: "code",
          rules: [{ required: !0, message: m("en-US", "mfaCodeRequired") }],
          children: /* @__PURE__ */ e(W, { placeholder: m("en-US", "mfaPlaceholderCode") })
        }
      ),
      /* @__PURE__ */ e(M, { type: "primary", htmlType: "submit", block: !0, loading: n, children: m("en-US", "verifyButton") })
    ] })
  ] });
};
function wn(t) {
  return typeof t == "object" && t !== null && t.isAxiosError === !0;
}
function as(t) {
  switch (t) {
    case "ACCOUNT":
      return 0;
    case "LOGIN":
      return 1;
    case "MFA_PHONE":
      return 2;
    case "MFA_CODE":
      return 3;
    case "DONE":
      return 4;
  }
}
const vl = () => {
  const { token: t } = Z.useToken(), { message: n } = xe.useApp(), [r, o] = I("ACCOUNT"), [i, a] = I(""), [l, s] = I(null), { register: c, loading: u } = Ln(), { login: h, loading: p } = Nn(), { registerSmsMfa: A, loading: C } = ao(), { verifySmsMfa: y, loading: v } = so();
  async function w(H) {
    s(null);
    try {
      const k = await c(H);
      a(k.userId), n.success(m("en-US", "accountCreatedSuccess")), o("LOGIN");
    } catch (k) {
      throw wn(k) && k.response?.status === 409 ? s({
        message: m("en-US", "emailAlreadyExists"),
        fieldErrors: { email: m("en-US", "emailAlreadyExists") }
      }) : s({
        message: m("en-US", "registrationError")
      }), k;
    }
  }
  async function P(H) {
    try {
      await h(H), n.success(m("en-US", "loginSuccess")), o("MFA_PHONE");
    } catch {
      n.error(m("en-US", "loginCheckError"));
    }
  }
  async function b(H) {
    try {
      await A(H), n.success(m("en-US", "mfaInitiatedSuccess")), o("MFA_CODE");
    } catch (k) {
      wn(k) && k.response?.status === 400 ? s({
        message: m("en-US", "invalidPhoneNumber"),
        fieldErrors: {
          phoneNumber: m("en-US", "invalidPhoneNumberField")
        }
      }) : s({
        message: m("en-US", "registerPhoneNumberError")
      }), n.error(m("en-US", "mfaPhoneError"));
    }
  }
  async function O(H) {
    try {
      await y({ userId: i, code: H }), n.success(m("en-US", "mfaVerifiedSuccess")), o("DONE");
    } catch {
      n.error(m("en-US", "mfaCodeError"));
    }
  }
  let F;
  return r === "ACCOUNT" ? F = /* @__PURE__ */ e(
    ns,
    {
      onNext: w,
      loading: u,
      serverError: l
    }
  ) : r === "LOGIN" ? F = /* @__PURE__ */ e(rs, { onLogin: P, loading: p }) : r === "MFA_PHONE" ? F = /* @__PURE__ */ e(os, { onNext: b, loading: C }) : r === "MFA_CODE" ? F = /* @__PURE__ */ e(is, { onVerify: O, loading: v }) : F = /* @__PURE__ */ e(ts, {}), /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: t.colorBgBase,
        padding: t.paddingLG
      },
      children: /* @__PURE__ */ d(
        ze,
        {
          style: {
            maxWidth: 600,
            width: "100%",
            padding: t.paddingMD,
            backgroundColor: t.colorBgContainer,
            boxShadow: t.boxShadow
          },
          children: [
            /* @__PURE__ */ e(
              _t,
              {
                current: as(r),
                style: { marginBottom: t.marginLG },
                items: [
                  { title: m("en-US", "registrationStepAccount") },
                  { title: m("en-US", "registrationStepLogin") },
                  { title: m("en-US", "registrationStepPhone") },
                  { title: m("en-US", "registrationStepCode") },
                  { title: m("en-US", "registrationStepDone") }
                ]
              }
            ),
            F
          ]
        }
      )
    }
  );
}, { Content: ss } = le, { Title: ls, Text: cs } = $, kl = ({ user: t }) => {
  const n = typeof t.avatar == "string" ? t.avatar : void 0;
  return /* @__PURE__ */ e(le, { style: { backgroundColor: "#f9f9f9" }, children: /* @__PURE__ */ d(ss, { style: { padding: "40px 24px" }, children: [
    /* @__PURE__ */ e(gt, { justify: "center", style: { textAlign: "center", marginBottom: 40 }, children: /* @__PURE__ */ d(it, { children: [
      /* @__PURE__ */ e(
        _n,
        {
          size: 96,
          src: n,
          style: { backgroundColor: "#1890ff", marginBottom: 16 },
          children: t.displayName.charAt(0)
        }
      ),
      /* @__PURE__ */ e(ls, { level: 3, children: t.displayName }),
      /* @__PURE__ */ e(cs, { type: "secondary", children: t.email })
    ] }) }),
    /* @__PURE__ */ e(gt, { justify: "center", children: /* @__PURE__ */ e(it, { xs: 24, sm: 20, md: 16, lg: 12, children: /* @__PURE__ */ d(
      de,
      {
        bordered: !0,
        column: 1,
        layout: "vertical",
        style: { backgroundColor: "#fff", padding: 24, borderRadius: 12 },
        children: [
          /* @__PURE__ */ e(de.Item, { label: "Full Name", children: t.fullName || "N/A" }),
          /* @__PURE__ */ e(de.Item, { label: "Preferred Name", children: t.preferredName || "N/A" }),
          /* @__PURE__ */ e(de.Item, { label: "Given Name", children: t.givenName || "N/A" }),
          /* @__PURE__ */ e(de.Item, { label: "Family Name", children: t.familyName || "N/A" }),
          /* @__PURE__ */ e(de.Item, { label: "Status", children: t.active ? /* @__PURE__ */ e(be, { color: "green", children: "Active" }) : /* @__PURE__ */ e(be, { color: "red", children: "Inactive" }) }),
          /* @__PURE__ */ e(de.Item, { label: "Feature Flags", children: t.featureFlags?.length ? t.featureFlags.map((r) => /* @__PURE__ */ e(be, { color: "blue", children: r }, r)) : "None" })
        ]
      }
    ) }) })
  ] }) });
}, Cl = () => {
  const { toggleTheme: t } = At();
  return t;
}, xl = () => !xt.useBreakpoint().md, _l = () => new Promise((t, n) => {
  if (!navigator.geolocation) {
    n(new Error("Geolocation is not supported by this browser."));
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (r) => {
      const { latitude: o, longitude: i } = r.coords;
      t({ latitude: o, longitude: i });
    },
    (r) => {
      n(new Error(`Failed to get location: ${r.message}`));
    },
    {
      enableHighAccuracy: !0,
      timeout: 1e4,
      maximumAge: 0
    }
  );
});
function Tl() {
  const { message: t } = xe.useApp();
  return {
    success(n) {
      t.success(n);
    },
    error(n) {
      t.error(n);
    }
  };
}
export {
  Hs as ActionFooter,
  zs as AdminFooter,
  js as AnalyticsFooter,
  Ll as AppThemeProvider,
  ol as BalanceWidget,
  Bs as BreadcrumbComponent,
  fl as Button,
  Fs as CardUI,
  nl as ClassificationTree,
  $s as ContentWrapper,
  hl as CsvDropzone,
  rl as CurrencyInput,
  Ho as CustomBarShape,
  Uo as DEFAULT_SIDEBAR_HEADER_OFFSET,
  En as DateRangePicker,
  ts as DoneScreen,
  Mn as Drawer,
  Ne as FOOTER_MIN_HEIGHT,
  sl as FeatureUsageDashboard,
  qs as FooterComponent,
  Ys as HeaderComponent,
  al as InvoicePreviewModal,
  il as InvoiceTable,
  Gs as LegalBar,
  bl as Login,
  Pn as LogoComponent,
  wl as Logout,
  ho as MarketingFooter,
  gl as MemberSignupWidget,
  he as MoneyField,
  Js as PriceScheduleCreateWizard,
  el as PriceScheduleEditModal,
  Zs as PriceScheduleTimeline,
  ml as ProductVariantModal,
  Yo as RANGE_ERROR_END_AFTER_START,
  Ko as RANGE_ERROR_OVERLAP,
  Sl as Register,
  vl as RegistrationWizard,
  In as SAFE_AREA_INSET_BOTTOM,
  Ks as SidebarComponent,
  ui as SignupForm,
  st as StatusChip,
  ns as StepAccountForm,
  is as StepMfaCodeForm,
  os as StepMfaPhoneForm,
  ll as SystemHealthWidget,
  Ws as TableFooterBar,
  Xs as TagChip,
  Vs as TenantFooter,
  cl as TenantOnboardingWizard,
  pl as TextInput,
  yl as ThemeToggle,
  kl as UserProfilePage,
  ul as WebBrandingProvider,
  ot as cloneDataNodes,
  Eo as createSidebarViewportStyle,
  Il as dark,
  Fn as filterTree,
  ft as findNode,
  Ae as findParent,
  tl as flatten,
  Nt as formatCurrency,
  Te as fromDataNode,
  _l as getBrowserLocation,
  Os as getSafeAreaPaddingBottom,
  mn as indentNode,
  Dl as light,
  rt as maxDepth,
  un as moveNodeDown,
  dn as moveNodeUp,
  hn as outdentNode,
  yt as removeNode,
  _a as resolveSocialAuthReturnTo,
  Sa as resolveSocialReturnTo,
  pt as toDataNode,
  Rn as updateTitle,
  li as useCreateTenantMutation,
  xl as useIsMobile,
  Tl as useNotifications,
  Qs as usePersistentSidebarOpenKeys,
  Pl as useTheme,
  Cl as useThemeToggle,
  dl as useWebBranding,
  Ct as withExternalAuthSync
};
//# sourceMappingURL=index.js.map
